/* eslint-disable no-mixed-operators */
/* Motor de plantillas del Estudio de Redes.
   Cada plantilla dibuja en un canvas en el segundo t:  render(ctx, W, H, t, D, o)
   D = datos de la obra (fotos reales de la cámara, días, clima)   o = opciones editables */
// ───────── utilidades ─────────
const IMGS = {};
function img(src) {
  if (!src) return null;
  let im = IMGS[src];
  if (!im) { im = new Image(); if (/^https?:/.test(src)) im.crossOrigin = 'anonymous'; im.src = src; IMGS[src] = im; }
  return im.complete && im.naturalWidth ? im : null;
}
function preload(list) {
  return Promise.all(list.map(src => new Promise(res => {
    const im = IMGS[src] || (IMGS[src] = new Image());
    if (im.complete && im.naturalWidth) return res();
    im.onload = im.onerror = () => res();
    if (!im.src) { if (/^https?:/.test(src)) im.crossOrigin = 'anonymous'; im.src = src; }
  })));
}
const clamp = (v, a = 0, b = 1) => Math.max(a, Math.min(b, v));
const lerp = (a, b, t) => a + (b - a) * t;
const easeOut = t => 1 - Math.pow(1 - clamp(t), 3);
const easeInOut = t => { t = clamp(t); return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
const seg = (t, a, b) => clamp((t - a) / (b - a));

// Estilo de la variante (tipografía de títulos, filtro de foto y encuadre). Lo setea quien dibuja antes de cada render.
const STYLE = { fam: null, filter: 'none', dx: 0 };
function setEstilo(e) { STYLE.fam = (e && e.fam) || null; STYLE.filter = (e && e.filter) || 'none'; STYLE.dx = (e && e.dx) || 0; }
function cover(ctx, src, x, y, w, h, zoom = 1, fx = .5, fy = .5) {
  fx = Math.max(0, Math.min(1, fx + STYLE.dx));
  const im = typeof src === 'string' ? img(src) : src;
  if (!im) { ctx.fillStyle = '#1b2420'; ctx.fillRect(x, y, w, h); return; }
  const r = Math.max(w / im.naturalWidth, h / im.naturalHeight) * zoom;
  const iw = im.naturalWidth * r, ih = im.naturalHeight * r;
  ctx.save(); ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
  if (STYLE.filter !== 'none' && ctx.filter === 'none') ctx.filter = STYLE.filter;
  ctx.drawImage(im, x + (w - iw) * fx, y + (h - ih) * fy, iw, ih);
  ctx.restore();
}
function rr(ctx, x, y, w, h, r) {
  ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
}
function shade(ctx, W, H, top = .55, bottom = .85, from = .0, to = 1) {
  const g = ctx.createLinearGradient(0, H * from, 0, H * to);
  g.addColorStop(0, `rgba(0,0,0,${top})`); g.addColorStop(.35, 'rgba(0,0,0,0)');
  g.addColorStop(.55, 'rgba(0,0,0,0)'); g.addColorStop(1, `rgba(0,0,0,${bottom})`);
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
}
function font(size, weight = 700, fam = 'Poppins') { return `${weight} ${Math.round(size)}px "${fam}", system-ui, sans-serif`; }
// texto con salto de línea; devuelve alto usado
function text(ctx, str, x, y, o = {}) {
  const size = o.size || 40, lh = o.lh || 1.12, maxW = o.maxW || 9999;
  ctx.font = font(size, o.weight || 700, o.fam || ((o.weight || 700) >= 700 && STYLE.fam) || 'Poppins');
  ctx.fillStyle = o.color || '#fff'; ctx.textAlign = o.align || 'left'; ctx.textBaseline = 'top';
  if (o.ls) ctx.letterSpacing = o.ls + 'px'; else ctx.letterSpacing = '0px';
  const words = String(str).split(' '), lines = []; let line = '';
  for (const w of words) {
    const test = line ? line + ' ' + w : w;
    if (ctx.measureText(test).width > maxW && line) { lines.push(line); line = w; } else line = test;
  }
  if (line) lines.push(line);
  const bottomUp = o.base === 'bottom';
  const total = lines.length * size * lh;
  let yy = bottomUp ? y - total : y;
  if (o.shadow) { ctx.shadowColor = 'rgba(0,0,0,.45)'; ctx.shadowBlur = size * .35; ctx.shadowOffsetY = size * .06; }
  for (const l of lines) { ctx.fillText(l, x, yy); yy += size * lh; }
  ctx.shadowColor = 'transparent'; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0; ctx.letterSpacing = '0px';
  return total;
}
function pill(ctx, str, x, y, o = {}) {
  const size = o.size || 26, padX = size * .7, padY = size * .42;
  ctx.font = font(size, o.weight || 600); ctx.letterSpacing = (o.ls ?? 1.5) + 'px';
  const w = ctx.measureText(str).width + padX * 2, h = size + padY * 2;
  const xx = o.align === 'right' ? x - w : o.align === 'center' ? x - w / 2 : x;
  rr(ctx, xx, y, w, h, h / 2); ctx.fillStyle = o.bg || 'rgba(0,0,0,.45)'; ctx.fill();
  if (o.stroke) { ctx.strokeStyle = o.stroke; ctx.lineWidth = 2; ctx.stroke(); }
  ctx.fillStyle = o.color || '#fff'; ctx.textBaseline = 'middle'; ctx.textAlign = 'left';
  ctx.fillText(str, xx + padX, y + h / 2 + size * .04); ctx.letterSpacing = '0px';
  return { w, h };
}
function dot(ctx, x, y, r, c) { ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fillStyle = c; ctx.fill(); }
const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const MESES_L = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
function fdate(iso, largo) { const [y, m, d] = iso.split('-').map(Number); return largo ? `${d} de ${MESES_L[m - 1]} ${y}` : `${d} ${MESES[m - 1]} ${y}`; }
function fmes(iso) { const [y, m] = iso.split('-').map(Number); return `${MESES[m - 1]} ${String(y).slice(2)}`; }
function num(n) { return Math.round(n).toLocaleString('es-AR'); }
function pickN(arr, n) { if (arr.length <= n) return arr.slice(); const out = []; for (let i = 0; i < n; i++) out.push(arr[Math.round(i * (arr.length - 1) / (n - 1))]); return out; }

// capa común de marca: chip del cliente arriba y firma abajo
function brand(ctx, W, H, D, o, pos = {}) {
  const s = W / 1080;
  if (o.chip !== false) {
    const x = pos.chipX ?? 60 * s, y = pos.chipY ?? 70 * s;
    const lg = D.logoSrc ? img(D.logoSrc) : null;
    if (lg) {
      // logo del cliente sobre una placa blanca (se lee sobre cualquier foto)
      const ratio = lg.naturalWidth / lg.naturalHeight, w = Math.min(280 * s, 72 * s * ratio), h = w / ratio;
      rr(ctx, x, y, w + 32 * s, h + 24 * s, 16 * s); ctx.fillStyle = 'rgba(255,255,255,.94)'; ctx.fill();
      ctx.drawImage(lg, x + 16 * s, y + 12 * s, w, h);
    } else {
      pill(ctx, D.cliente.toUpperCase(), x, y, { size: 24 * s, bg: 'rgba(0,0,0,.42)', ls: 2 * s });
    }
  }
  if (o.marca !== false) {
    const label = 'CÁMARA LISUAL · EN VIVO', size = 20 * s, base = pos.markY ?? H - 44 * s;
    ctx.font = font(size, 600); ctx.letterSpacing = 1.5 * s + 'px';
    const tw = ctx.measureText(label).width, r = 6 * s, padX = 16 * s, h = size + 18 * s, w = tw + padX * 2 + r * 2 + 10 * s;
    const x0 = W - 40 * s - w, y0 = base - h + 8 * s;
    rr(ctx, x0, y0, w, h, h / 2); ctx.fillStyle = 'rgba(0,0,0,.45)'; ctx.fill();
    dot(ctx, x0 + padX + r, y0 + h / 2, r, o.accent);
    ctx.fillStyle = 'rgba(255,255,255,.92)'; ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.fillText(label, x0 + padX + r * 2 + 10 * s, y0 + h / 2 + s);
    ctx.letterSpacing = '0px';
  }
}
function progress(ctx, W, y, p, o, s) {
  rr(ctx, 60 * s, y, W - 120 * s, 8 * s, 4 * s); ctx.fillStyle = 'rgba(255,255,255,.25)'; ctx.fill();
  rr(ctx, 60 * s, y, Math.max(8 * s, (W - 120 * s) * p), 8 * s, 4 * s); ctx.fillStyle = o.accent; ctx.fill();
}
function dayOf(D, iso) { return Math.max(1, Math.round((new Date(iso) - new Date(D.inicio)) / 864e5) + 1); }

// ───────── plantillas ─────────
const T = [];
const add = (t) => T.push(t);

add({ id: 'tl-clasico', nombre: 'Timelapse de avance', tipo: 'reel', fmt: '9:16', dur: 9, cat: ['timelapse', 'reel'],
  desc: 'Toda la obra en 9 segundos, con contador de días.',
  titulo: 'Así avanza {obra}', sub: '{lugar}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(D.hist, 18), n = fr.length, per = this.dur * .92 / n;
    const i = Math.min(n - 1, Math.floor(t / per)), f = clamp((t - i * per) / (per * .45));
    cover(ctx, fr[i].src, 0, 0, W, H, 1.06 - .04 * (t / this.dur));
    if (i + 1 < n && f > 0) { ctx.globalAlpha = 0; }
    if (i > 0 && f < 1) { ctx.globalAlpha = 1 - f; cover(ctx, fr[i - 1].src, 0, 0, W, H, 1.06 - .04 * (t / this.dur)); }
    ctx.globalAlpha = 1; shade(ctx, W, H, .55, .9);
    brand(ctx, W, H, D, o);
    text(ctx, o.titulo, 60 * s, 170 * s, { size: 84 * s, maxW: W - 120 * s, shadow: 1, weight: 700 });
    text(ctx, o.sub, 60 * s, 170 * s + 190 * s, { size: 34 * s, weight: 500, color: 'rgba(255,255,255,.85)' });
    const dia = dayOf(D, fr[i].fecha);
    ctx.font = font(30 * s, 600); ctx.fillStyle = o.accent; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
    ctx.fillText('DÍA', 60 * s, H - 250 * s);
    text(ctx, num(dia), 60 * s, H - 240 * s, { size: 150 * s, weight: 700 });
    text(ctx, fdate(fr[i].fecha, true), W - 60 * s, H - 150 * s, { size: 32 * s, weight: 500, align: 'right', color: 'rgba(255,255,255,.85)' });
    progress(ctx, W, H - 90 * s, (i + f) / (n - 1 || 1), o, s);
  } });

add({ id: 'tl-flash', nombre: 'Flash de obra', tipo: 'reel', fmt: '9:16', dur: 6, cat: ['timelapse', 'reel'], trend: 1,
  desc: 'Cortes rápidos al ritmo, remate con los días de obra.',
  titulo: '{dias} días', sub: 'de {obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = D.hist, cut = .16, end = 4.4;
    const i = t < end ? Math.floor(t / cut) % fr.length : fr.length - 1;
    const z = t < end ? 1.12 - (t % cut) / cut * .06 : 1.02 + .03 * seg(t, end, 6);
    cover(ctx, fr[Math.min(i, fr.length - 1)].src, 0, 0, W, H, z);
    const flash = t < end ? Math.max(0, 1 - (t % cut) / cut * 3) * .35 : Math.max(0, 1 - (t - end) * 4) * .9;
    if (flash > 0) { ctx.fillStyle = `rgba(255,255,255,${flash})`; ctx.fillRect(0, 0, W, H); }
    ctx.fillStyle = 'rgba(0,0,0,.28)'; ctx.fillRect(0, 0, W, H);
    brand(ctx, W, H, D, o);
    if (t < end) {
      const d = fr[Math.min(i, fr.length - 1)];
      pill(ctx, fmes(d.fecha).toUpperCase(), W / 2, H * .82, { size: 40 * s, align: 'center', bg: o.accent, color: '#06100b', ls: 3 * s });
    } else {
      const k = easeOut(seg(t, end, end + .5));
      ctx.save(); ctx.translate(W / 2, H * .44); ctx.scale(1.4 - .4 * k, 1.4 - .4 * k); ctx.globalAlpha = k;
      text(ctx, o.titulo.toUpperCase(), 0, -110 * s, { size: 170 * s, align: 'center', weight: 700, color: o.accent, shadow: 1 });
      text(ctx, o.sub, 0, 90 * s, { size: 54 * s, align: 'center', weight: 600, maxW: W * .8, shadow: 1 });
      ctx.restore(); ctx.globalAlpha = 1;
    }
  } });

add({ id: 'ad-barrido', nombre: 'Antes / Después barrido', tipo: 'reel', fmt: '9:16', dur: 6, cat: ['reel', 'story'],
  desc: 'La primera foto y la de hoy, con una cortina que revela el avance.',
  titulo: 'Del primer día a hoy', sub: '{obra} · {meses} de obra',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, a = D.hist[0], b = D.heroItem;
    const p = easeInOut(seg(t, 1, 4.2)), x = W * p;
    cover(ctx, a.src, 0, 0, W, H, 1.05);
    ctx.save(); ctx.beginPath(); ctx.rect(0, 0, x, H); ctx.clip(); cover(ctx, b.src, 0, 0, W, H, 1.05); ctx.restore();
    shade(ctx, W, H, .5, .75);
    if (p > 0 && p < 1) { ctx.fillStyle = '#fff'; ctx.fillRect(x - 3 * s, 0, 6 * s, H); dot(ctx, x, H * .55, 34 * s, '#fff'); ctx.fillStyle = '#111'; ctx.font = font(30 * s, 700); ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('‹ ›', x, H * .55 + 2 * s); }
    brand(ctx, W, H, D, o);
    if (p < .5) pill(ctx, 'ANTES · ' + fdate(a.fecha).toUpperCase(), W - 60 * s, H * .72, { size: 28 * s, align: 'right', ls: 2 * s });
    if (p > .5) pill(ctx, 'HOY · ' + fdate(D.hoyFecha).toUpperCase(), 60 * s, H * .72, { size: 28 * s, bg: o.accent, color: '#06100b', ls: 2 * s });
    text(ctx, o.titulo, 60 * s, 170 * s, { size: 80 * s, maxW: W - 120 * s, shadow: 1 });
    text(ctx, o.sub, 60 * s, H - 200 * s, { size: 36 * s, weight: 500, maxW: W - 120 * s, color: 'rgba(255,255,255,.9)' });
  } });

add({ id: 'ad-diagonal', nombre: 'Antes / Después diagonal', tipo: 'post', fmt: '4:5', dur: 0, cat: ['post'],
  desc: 'Portada en diagonal estilo Lisual Studio, lista para el feed.',
  titulo: 'La obra que sí se muestra', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, a = D.hist[0], b = D.heroItem;
    cover(ctx, a.src, 0, 0, W, H, 1.02, .35);
    ctx.save(); ctx.beginPath(); ctx.moveTo(W * .63, 0); ctx.lineTo(W, 0); ctx.lineTo(W, H); ctx.lineTo(W * .37, H); ctx.closePath(); ctx.clip();
    cover(ctx, b.src, 0, 0, W, H, 1.02, .65); ctx.restore();
    ctx.save(); ctx.shadowColor = o.accent; ctx.shadowBlur = 30 * s; ctx.strokeStyle = '#fff'; ctx.lineWidth = 7 * s;
    ctx.beginPath(); ctx.moveTo(W * .63, 0); ctx.lineTo(W * .37, H); ctx.stroke(); ctx.restore();
    const g = ctx.createLinearGradient(0, H * .55, 0, H); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,.8)'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    pill(ctx, 'ANTES', 50 * s, 60 * s, { size: 30 * s, ls: 4 * s });
    pill(ctx, 'DESPUÉS', W - 50 * s, 60 * s, { size: 30 * s, align: 'right', bg: o.accent, color: '#06100b', ls: 4 * s });
    ctx.fillStyle = o.accent; ctx.fillRect(60 * s, H - 330 * s, 90 * s, 6 * s);
    text(ctx, o.titulo, 60 * s, H - 300 * s, { size: 70 * s, maxW: W - 120 * s, shadow: 1 });
    text(ctx, o.sub + ' · ' + D.meses + ' de obra', 60 * s, H - 110 * s, { size: 30 * s, weight: 500, color: 'rgba(255,255,255,.85)' });
  } });

add({ id: 'kenburns', nombre: 'Portada cinematográfica', tipo: 'story', fmt: '9:16', dur: 7, cat: ['story', 'reel'],
  desc: 'La mejor foto de hoy con zoom lento y título que entra.',
  titulo: 'Hoy en {obra}', sub: 'Fotos reales, tomadas hoy por nuestra cámara',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, k = t / this.dur;
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1 + .16 * easeInOut(k), .5 + .08 * k, .5);
    shade(ctx, W, H, .35, .92);
    brand(ctx, W, H, D, o);
    const a1 = easeOut(seg(t, .6, 1.5)), a2 = easeOut(seg(t, 1.2, 2.1));
    ctx.globalAlpha = a1; ctx.fillStyle = o.accent; ctx.fillRect(60 * s, H - 560 * s + (1 - a1) * 40 * s, 110 * s, 8 * s);
    text(ctx, o.titulo, 60 * s, H - 530 * s + (1 - a1) * 40 * s, { size: 96 * s, maxW: W - 120 * s, shadow: 1 });
    ctx.globalAlpha = a2; text(ctx, o.sub, 60 * s, H - 260 * s + (1 - a2) * 30 * s, { size: 36 * s, weight: 400, maxW: W - 160 * s, color: 'rgba(255,255,255,.9)' });
    pill(ctx, '● EN VIVO · ' + D.heroItem.hora, 60 * s, H - 150 * s, { size: 26 * s, bg: 'rgba(230,40,40,.9)', ls: 2 * s });
    ctx.globalAlpha = 1;
  } });

add({ id: 'un-dia', nombre: 'Un día en obra', tipo: 'reel', fmt: '9:16', dur: 8, cat: ['reel', 'timelapse'], trend: 1,
  desc: 'De las 8 a las 18 de hoy, con reloj en pantalla.',
  titulo: 'Un día en {obra}', sub: '{hoyLargo}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = D.hoy.length ? D.hoy : [D.heroItem], n = fr.length, per = this.dur / n;
    const i = Math.min(n - 1, Math.floor(t / per)), f = clamp((t - i * per) / per);
    cover(ctx, fr[i].src, 0, 0, W, H, 1.04);
    if (i + 1 < n && f > .6) { ctx.globalAlpha = (f - .6) / .4; cover(ctx, fr[i + 1].src, 0, 0, W, H, 1.04); ctx.globalAlpha = 1; }
    shade(ctx, W, H, .5, .8);
    brand(ctx, W, H, D, o);
    const h0 = parseInt(fr[i].hora), mins = Math.floor(f * 60);
    const clock = `${String(h0).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
    text(ctx, clock, W / 2, H * .38, { size: 210 * s, align: 'center', weight: 600, shadow: 1 });
    text(ctx, o.titulo, W / 2, H * .38 + 250 * s, { size: 54 * s, align: 'center', maxW: W - 160 * s, shadow: 1 });
    text(ctx, o.sub, W / 2, H * .38 + 330 * s, { size: 32 * s, align: 'center', weight: 500, color: 'rgba(255,255,255,.85)' });
    const sun = (h0 + mins / 60 - 8) / 10;
    ctx.strokeStyle = 'rgba(255,255,255,.5)'; ctx.lineWidth = 3 * s; ctx.beginPath(); ctx.arc(W / 2, H - 140 * s, 300 * s, Math.PI, 2 * Math.PI); ctx.stroke();
    const ang = Math.PI + Math.PI * clamp(sun); dot(ctx, W / 2 + Math.cos(ang) * 300 * s, H - 140 * s + Math.sin(ang) * 300 * s, 22 * s, o.accent);
  } });

add({ id: 'contador', nombre: 'Contador de días', tipo: 'story', fmt: '9:16', dur: 5, cat: ['story'],
  desc: 'Un número grande que cuenta los días de obra documentados.',
  titulo: 'días construyendo {obra}', sub: 'y cada uno quedó registrado',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, k = easeOut(seg(t, .3, 2.6));
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.1 - .05 * k);
    ctx.fillStyle = 'rgba(6,12,9,.62)'; ctx.fillRect(0, 0, W, H);
    brand(ctx, W, H, D, o);
    text(ctx, num(D.dias * k), W / 2, H * .3, { size: 330 * s, align: 'center', weight: 700, color: o.accent });
    text(ctx, o.titulo, W / 2, H * .3 + 380 * s, { size: 58 * s, align: 'center', maxW: W - 160 * s });
    ctx.globalAlpha = seg(t, 2.4, 3.2);
    text(ctx, o.sub, W / 2, H * .3 + 560 * s, { size: 36 * s, align: 'center', weight: 400, color: 'rgba(255,255,255,.85)', maxW: W - 200 * s });
    text(ctx, '+' + num(D.fotos) + ' fotos · ' + D.meses, W / 2, H - 230 * s, { size: 34 * s, align: 'center', weight: 600 });
    ctx.globalAlpha = 1;
  } });

add({ id: 'tres-actos', nombre: 'Tres actos', tipo: 'story', fmt: '9:16', dur: 6, cat: ['story'],
  desc: 'Inicio, proceso y hoy, apilados en una historia.',
  titulo: 'Inicio · Proceso · Hoy', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, h = D.hist, fr = [h[0], h[Math.floor(h.length / 2)], D.heroItem], lab = ['INICIO', 'PROCESO', 'HOY'];
    ctx.fillStyle = '#070B09'; ctx.fillRect(0, 0, W, H);
    const top = 230 * s, gap = 16 * s, bh = (H - top - 140 * s - gap * 2) / 3;
    fr.forEach((f, i) => {
      const k = easeOut(seg(t, .3 + i * .7, 1.1 + i * .7)), y = top + i * (bh + gap);
      ctx.save(); ctx.globalAlpha = k; ctx.translate((1 - k) * (i % 2 ? -1 : 1) * W * .3, 0);
      rr(ctx, 40 * s, y, W - 80 * s, bh, 26 * s); ctx.save(); ctx.clip(); cover(ctx, f.src, 40 * s, y, W - 80 * s, bh, 1.05 + .03 * t / 6); ctx.restore();
      pill(ctx, lab[i], 70 * s, y + 26 * s, { size: 26 * s, bg: i === 2 ? o.accent : 'rgba(0,0,0,.55)', color: i === 2 ? '#06100b' : '#fff', ls: 3 * s });
      text(ctx, fdate(f.fecha || D.hoyFecha), W - 70 * s, y + bh - 70 * s, { size: 30 * s, align: 'right', weight: 600, shadow: 1 });
      ctx.restore();
    });
    text(ctx, o.titulo, 60 * s, 80 * s, { size: 60 * s, maxW: W - 120 * s });
    text(ctx, o.sub, 60 * s, 160 * s, { size: 30 * s, weight: 500, color: o.accent });
    brand(ctx, W, H, Object.assign({}, D), Object.assign({}, o, { chip: false }), { markY: H - 60 * s });
  } });

add({ id: 'mes-a-mes', nombre: 'Mes a mes', tipo: 'post', fmt: '1:1', dur: 6, cat: ['post', 'timelapse'],
  desc: 'Nueve fotos, una por etapa, que aparecen en orden.',
  titulo: 'Mes a mes', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(D.hist.concat([D.heroItem]), 9), g = 10 * s, top = 150 * s, cw = (W - 80 * s - g * 2) / 3, ch = (H - top - 50 * s - g * 2) / 3;
    ctx.fillStyle = '#070B09'; ctx.fillRect(0, 0, W, H);
    text(ctx, o.titulo, 40 * s, 40 * s, { size: 56 * s });
    text(ctx, o.sub, W - 40 * s, 58 * s, { size: 28 * s, align: 'right', weight: 500, color: o.accent });
    fr.forEach((f, i) => {
      const k = easeOut(seg(t, .2 + i * .35, .6 + i * .35)), x = 40 * s + (i % 3) * (cw + g), y = top + Math.floor(i / 3) * (ch + g);
      if (k <= 0) { rr(ctx, x, y, cw, ch, 14 * s); ctx.fillStyle = '#121a16'; ctx.fill(); return; }
      ctx.save(); ctx.globalAlpha = k; ctx.translate(x + cw / 2, y + ch / 2); ctx.scale(.85 + .15 * k, .85 + .15 * k);
      rr(ctx, -cw / 2, -ch / 2, cw, ch, 14 * s); ctx.clip(); cover(ctx, f.src, -cw / 2, -ch / 2, cw, ch);
      const lbl = f.fecha ? fmes(f.fecha) : 'hoy';
      pill(ctx, lbl.toUpperCase(), -cw / 2 + 12 * s, ch / 2 - 56 * s, { size: 20 * s, bg: i === 8 ? o.accent : 'rgba(0,0,0,.55)', color: i === 8 ? '#06100b' : '#fff', ls: 2 * s });
      ctx.restore();
    });
  } });

add({ id: 'polaroids', nombre: 'Polaroids', tipo: 'story', fmt: '9:16', dur: 6, cat: ['story'], trend: 1,
  desc: 'Fotos instantáneas que caen con su fecha escrita.',
  titulo: 'Nuestro álbum de obra', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(D.hist.concat([D.heroItem]), 6);
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.2); ctx.fillStyle = 'rgba(7,11,9,.78)'; ctx.fillRect(0, 0, W, H);
    text(ctx, o.titulo, W / 2, 110 * s, { size: 66 * s, align: 'center', maxW: W - 140 * s });
    text(ctx, o.sub, W / 2, 200 * s, { size: 32 * s, align: 'center', weight: 500, color: o.accent });
    const pos = [[.3, .36, -8], [.7, .38, 7], [.32, .56, 5], [.68, .58, -6], [.36, .76, -3], [.64, .78, 9]];
    fr.forEach((f, i) => {
      const k = easeOut(seg(t, .3 + i * .55, .9 + i * .55)); if (k <= 0) return;
      const pw = 430 * s, ph = 500 * s, [px, py, rot] = pos[i];
      ctx.save(); ctx.translate(W * px, H * py - (1 - k) * 300 * s); ctx.rotate((rot + (1 - k) * 20) * Math.PI / 180); ctx.globalAlpha = k;
      ctx.shadowColor = 'rgba(0,0,0,.5)'; ctx.shadowBlur = 30 * s; ctx.fillStyle = '#f7f5ef'; ctx.fillRect(-pw / 2, -ph / 2, pw, ph); ctx.shadowColor = 'transparent';
      cover(ctx, f.src, -pw / 2 + 22 * s, -ph / 2 + 22 * s, pw - 44 * s, pw - 44 * s);
      ctx.font = font(34 * s, 500, 'Caveat'); ctx.fillStyle = '#26302b'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(f.fecha ? fdate(f.fecha) : 'hoy ✓', 0, ph / 2 - 50 * s);
      ctx.restore();
    });
    brand(ctx, W, H, D, Object.assign({}, o, { chip: false }));
  } });

add({ id: 'pelicula', nombre: 'Rollo de película', tipo: 'reel', fmt: '9:16', dur: 7, cat: ['reel', 'timelapse'],
  desc: 'Los fotogramas de la obra pasando como una película.',
  titulo: 'La película de {obra}', sub: 'Filmada por Lisual desde el día 1',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = D.hist, fw = 560 * s, fh = 380 * s, gap = 30 * s, stripY = H * .42;
    ctx.fillStyle = '#0b0d0c'; ctx.fillRect(0, 0, W, H);
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.3); ctx.fillStyle = 'rgba(8,10,9,.84)'; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = '#151816'; ctx.fillRect(0, stripY - 70 * s, W, fh + 140 * s);
    const off = (t / this.dur) * (fr.length * (fw + gap) - W + 100 * s);
    for (let x = -((off) % (60 * s)); x < W; x += 60 * s) { ctx.fillStyle = '#2a2f2c'; rr(ctx, x, stripY - 50 * s, 32 * s, 24 * s, 5 * s); ctx.fill(); rr(ctx, x, stripY + fh + 26 * s, 32 * s, 24 * s, 5 * s); ctx.fill(); }
    fr.forEach((f, i) => {
      const x = 60 * s + i * (fw + gap) - off; if (x > W || x + fw < 0) return;
      cover(ctx, f.src, x, stripY, fw, fh);
      ctx.font = font(22 * s, 600, 'JetBrains Mono'); ctx.fillStyle = o.accent; ctx.textAlign = 'left'; ctx.textBaseline = 'top';
      ctx.fillText(fdate(f.fecha).toUpperCase(), x + 10 * s, stripY + fh + 60 * s);
    });
    text(ctx, o.titulo, 60 * s, 200 * s, { size: 82 * s, maxW: W - 120 * s });
    text(ctx, o.sub, 60 * s, H - 330 * s, { size: 36 * s, weight: 500, maxW: W - 120 * s, color: 'rgba(255,255,255,.85)' });
    brand(ctx, W, H, D, o);
  } });

add({ id: 'cuenta-regresiva', nombre: 'Cuenta regresiva', tipo: 'story', fmt: '9:16', dur: 5, cat: ['story'],
  desc: 'Cuántos días faltan para la entrega. Editá el número.',
  titulo: 'Faltan', sub: 'días para la entrega de {obra}', numero: 120,
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, n = Number(o.numero) || 0, k = easeOut(seg(t, .2, 2));
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.08); ctx.fillStyle = 'rgba(7,11,9,.55)'; ctx.fillRect(0, 0, W, H);
    brand(ctx, W, H, D, o);
    text(ctx, o.titulo.toUpperCase(), W / 2, H * .28, { size: 60 * s, align: 'center', ls: 12 * s });
    const shown = Math.round(lerp(n + 40, n, k));
    rr(ctx, W / 2 - 330 * s, H * .28 + 110 * s, 660 * s, 380 * s, 40 * s); ctx.fillStyle = o.accent; ctx.fill();
    text(ctx, String(shown), W / 2, H * .28 + 150 * s, { size: 280 * s, align: 'center', color: '#06100b' });
    text(ctx, o.sub, W / 2, H * .28 + 540 * s, { size: 46 * s, align: 'center', maxW: W - 180 * s, shadow: 1 });
    const pulse = .5 + .5 * Math.sin(t * 5);
    pill(ctx, 'Seguila en vivo 👀', W / 2, H - 260 * s, { size: 34 * s, align: 'center', bg: `rgba(255,255,255,${.12 + .1 * pulse})`, stroke: 'rgba(255,255,255,.5)' });
  } });

add({ id: 'clima', nombre: 'Parte del día', tipo: 'story', fmt: '9:16', dur: 5, cat: ['story'], trend: 1,
  desc: 'Foto de hoy con el clima real de la obra.',
  titulo: 'Parte de obra', sub: '{hoyLargo}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, c = D.clima || { temp: 18, desc: 'Parcialmente nublado', icon: '⛅', viento: 12 };
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.02 + .04 * t / 5);
    shade(ctx, W, H, .45, .6); brand(ctx, W, H, D, o);
    const k = easeOut(seg(t, .3, 1.2)), cy = H * .52 + (1 - k) * 80 * s;
    ctx.globalAlpha = k;
    rr(ctx, 60 * s, cy, W - 120 * s, 520 * s, 44 * s); ctx.fillStyle = 'rgba(12,18,15,.72)'; ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,.15)'; ctx.lineWidth = 2 * s; ctx.stroke();
    text(ctx, o.titulo.toUpperCase(), 110 * s, cy + 50 * s, { size: 28 * s, color: o.accent, ls: 4 * s, weight: 600 });
    text(ctx, o.sub, 110 * s, cy + 95 * s, { size: 34 * s, weight: 500 });
    text(ctx, c.icon, 110 * s, cy + 190 * s, { size: 150 * s, weight: 400 });
    text(ctx, Math.round(c.temp) + '°', 330 * s, cy + 170 * s, { size: 190 * s, weight: 600 });
    text(ctx, c.desc, 110 * s, cy + 400 * s, { size: 36 * s, weight: 500, maxW: W - 400 * s });
    text(ctx, 'Viento ' + Math.round(c.viento) + ' km/h', W - 110 * s, cy + 400 * s, { size: 30 * s, weight: 400, align: 'right', color: 'rgba(255,255,255,.75)' });
    ctx.globalAlpha = 1;
    text(ctx, D.obra + ' · ' + D.lugar, 60 * s, 170 * s, { size: 46 * s, maxW: W - 120 * s, shadow: 1 });
  } });

add({ id: 'encuesta', nombre: 'Encuesta interactiva', tipo: 'story', fmt: '9:16', dur: 5, cat: ['story'], trend: 1,
  desc: 'Pregunta con votación para sumar interacción en historias.',
  titulo: '¿Cuánto avanzó en {meses}?', sub: 'Deslizá para ver la respuesta 👆',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    cover(ctx, D.hist[0].src, 0, 0, W, H / 2, 1.05); cover(ctx, D.heroItem.src, 0, H / 2, W, H / 2, 1.05);
    ctx.fillStyle = 'rgba(0,0,0,.2)'; ctx.fillRect(0, 0, W, H);
    pill(ctx, 'ASÍ EMPEZÓ', 60 * s, 60 * s + 70 * s, { size: 26 * s, ls: 3 * s });
    pill(ctx, 'ASÍ ESTÁ HOY', 60 * s, H - 130 * s, { size: 26 * s, bg: o.accent, color: '#06100b', ls: 3 * s });
    const bw = W - 200 * s, bx = 100 * s, by = H / 2 - 230 * s;
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,.35)'; ctx.shadowBlur = 40 * s; rr(ctx, bx, by, bw, 460 * s, 36 * s); ctx.fillStyle = '#fff'; ctx.fill(); ctx.restore();
    text(ctx, o.titulo, W / 2, by + 44 * s, { size: 44 * s, align: 'center', color: '#101512', maxW: bw - 80 * s });
    const opts = [['Mucho 🚀', .78], ['Poco 🐢', .22]], k = easeOut(seg(t, 1.6, 3.2));
    opts.forEach(([l, v], i) => {
      const y = by + 190 * s + i * 120 * s; rr(ctx, bx + 40 * s, y, bw - 80 * s, 96 * s, 48 * s); ctx.fillStyle = '#eef1ef'; ctx.fill();
      rr(ctx, bx + 40 * s, y, Math.max(96 * s, (bw - 80 * s) * v * k), 96 * s, 48 * s); ctx.fillStyle = i ? '#cfd6d2' : o.accent; ctx.fill();
      text(ctx, l, bx + 80 * s, y + 26 * s, { size: 36 * s, color: '#101512', weight: 600 });
      if (k > .1) text(ctx, Math.round(v * 100 * k) + '%', bx + bw - 80 * s, y + 26 * s, { size: 36 * s, color: '#101512', align: 'right' });
    });
    text(ctx, o.sub, W / 2, H / 2 + 260 * s, { size: 30 * s, align: 'center', weight: 600, shadow: 1 });
  } });

add({ id: 'testimonio', nombre: 'Testimonio', tipo: 'post', fmt: '4:5', dur: 0, cat: ['post'],
  desc: 'Una frase del cliente sobre la foto de la obra.',
  titulo: '“Poder mostrar la obra en tiempo real le da confianza a cada comprador.”', sub: 'Equipo de {cliente}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    cover(ctx, D.heroItem.src, 0, 0, W, H * .52, 1.03);
    ctx.fillStyle = '#070B09'; ctx.fillRect(0, H * .52, W, H * .48);
    text(ctx, '“', 60 * s, H * .52 - 120 * s, { size: 260 * s, color: o.accent, fam: 'Playfair Display' });
    text(ctx, o.titulo, 70 * s, H * .52 + 90 * s, { size: 50 * s, weight: 500, maxW: W - 140 * s, lh: 1.25, fam: 'Playfair Display' });
    ctx.fillStyle = o.accent; ctx.fillRect(70 * s, H - 150 * s, 60 * s, 5 * s);
    text(ctx, o.sub, 150 * s, H - 172 * s, { size: 30 * s, weight: 600 });
    text(ctx, D.obra, 150 * s, H - 128 * s, { size: 26 * s, weight: 400, color: 'rgba(255,255,255,.65)' });
    brand(ctx, W, H, D, Object.assign({}, o, { marca: false }));
  } });

add({ id: 'dato', nombre: 'El dato', tipo: 'post', fmt: '1:1', dur: 0, cat: ['post'],
  desc: 'Una cifra grande para cortar el feed.',
  titulo: '{fotosN} fotos', sub: 'documentan cada día de {obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.05); ctx.fillStyle = 'rgba(7,11,9,.66)'; ctx.fillRect(0, 0, W, H);
    brand(ctx, W, H, D, o);
    text(ctx, 'EL DATO', 70 * s, 300 * s, { size: 30 * s, color: o.accent, ls: 6 * s, weight: 600 });
    text(ctx, o.titulo, 70 * s, 350 * s, { size: 150 * s, maxW: W - 140 * s, lh: 1 });
    text(ctx, o.sub, 70 * s, 700 * s, { size: 44 * s, weight: 500, maxW: W - 200 * s });
  } });

add({ id: 'revista', nombre: 'Tapa de revista', tipo: 'post', fmt: '4:5', dur: 0, cat: ['post'], trend: 1,
  desc: 'La obra como portada editorial.',
  titulo: '{obra}', sub: 'Edición {mesAnio} · Avance de obra',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.02);
    const g = ctx.createLinearGradient(0, 0, 0, H * .35); g.addColorStop(0, 'rgba(0,0,0,.55)'); g.addColorStop(1, 'rgba(0,0,0,0)'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    text(ctx, 'OBRA', W / 2, 30 * s, { size: 230 * s, align: 'center', fam: 'Playfair Display', weight: 700, ls: 10 * s });
    text(ctx, o.sub.toUpperCase(), W / 2, 285 * s, { size: 24 * s, align: 'center', weight: 600, ls: 5 * s });
    const b = ctx.createLinearGradient(0, H * .6, 0, H); b.addColorStop(0, 'rgba(0,0,0,0)'); b.addColorStop(1, 'rgba(0,0,0,.75)'); ctx.fillStyle = b; ctx.fillRect(0, 0, W, H);
    text(ctx, o.titulo, 60 * s, H - 70 * s, { size: 96 * s, fam: 'Playfair Display', maxW: W * .75, base: 'bottom', shadow: 1 });
    text(ctx, D.meses.toUpperCase() + ' DE OBRA', W - 60 * s, 380 * s, { size: 30 * s, align: 'right', color: o.accent, weight: 700, ls: 3 * s, shadow: 1 });
    text(ctx, '+' + num(D.fotos) + ' FOTOS', W - 60 * s, 425 * s, { size: 30 * s, align: 'right', weight: 700, ls: 3 * s, shadow: 1 });
  } });

add({ id: 'grilla-3x3', nombre: 'Mosaico para el perfil', tipo: 'post', fmt: '1:1', dur: 0, cat: ['post'],
  desc: 'Una foto partida en 9 posteos para armar el perfil.', slides: 9, slideFmt: '1:1',
  titulo: '{obra}', sub: '',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    if (o.slide != null && o.exporting) { const i = o.slide, r = Math.floor(i / 3), c = i % 3; ctx.save(); ctx.translate(-c * W, -r * H); ctx.scale(3, 3); this.full(ctx, W, H, D, o); ctx.restore(); return; }
    this.full(ctx, W, H, D, o);
    ctx.strokeStyle = '#070B09'; ctx.lineWidth = 8 * s; for (let i = 1; i < 3; i++) { ctx.beginPath(); ctx.moveTo(W * i / 3, 0); ctx.lineTo(W * i / 3, H); ctx.moveTo(0, H * i / 3); ctx.lineTo(W, H * i / 3); ctx.stroke(); }
  },
  full(ctx, W, H, D, o) {
    const s = W / 1080; cover(ctx, D.heroItem.src, 0, 0, W, H, 1);
    ctx.fillStyle = 'rgba(0,0,0,.25)'; ctx.fillRect(0, 0, W, H);
    text(ctx, o.titulo.toUpperCase(), W / 2, H / 2 - 60 * s, { size: 88 * s, align: 'center', maxW: W - 120 * s, shadow: 1, ls: 4 * s });
    ctx.fillStyle = o.accent; ctx.fillRect(W / 2 - 60 * s, H / 2 + 60 * s, 120 * s, 8 * s);
  } });

add({ id: 'carrusel-historia', nombre: 'Carrusel: la historia', tipo: 'carrusel', fmt: '4:5', dur: 0, cat: ['carrusel'], slides: 5,
  desc: 'Cinco láminas: portada, inicio, proceso, hoy y cierre.',
  titulo: 'La historia de {obra}', sub: 'Deslizá →',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, i = o.slide ?? Math.floor(t / 1.6) % 5, h = D.hist;
    const fr = [D.heroItem, h[0], h[Math.floor(h.length / 2)], D.heroItem, D.heroItem][i];
    cover(ctx, fr.src, 0, 0, W, H, i === 4 ? 1.2 : 1.03);
    ctx.fillStyle = i === 4 ? 'rgba(7,11,9,.8)' : 'rgba(0,0,0,.15)'; ctx.fillRect(0, 0, W, H); shade(ctx, W, H, .35, .85);
    pill(ctx, (i + 1) + ' / 5', W - 50 * s, 50 * s, { size: 24 * s, align: 'right' });
    if (i === 0) { text(ctx, o.titulo, 60 * s, H - 420 * s, { size: 92 * s, maxW: W - 120 * s, shadow: 1 }); text(ctx, o.sub, 60 * s, H - 130 * s, { size: 36 * s, color: o.accent }); }
    else if (i < 4) {
      const lab = ['', 'EL COMIENZO', 'EN PLENO AVANCE', 'HOY'][i], f = fr.fecha || D.hoyFecha;
      pill(ctx, lab, 60 * s, H - 300 * s, { size: 30 * s, bg: i === 3 ? o.accent : 'rgba(0,0,0,.55)', color: i === 3 ? '#06100b' : '#fff', ls: 3 * s });
      text(ctx, fdate(f, true), 60 * s, H - 210 * s, { size: 64 * s, shadow: 1 });
      text(ctx, 'Día ' + num(dayOf(D, f)) + ' de obra', 60 * s, H - 120 * s, { size: 32 * s, weight: 500, color: 'rgba(255,255,255,.85)' });
    } else {
      text(ctx, 'Seguí la obra en vivo', W / 2, H * .36, { size: 80 * s, align: 'center', maxW: W - 160 * s });
      text(ctx, D.ig, W / 2, H * .36 + 220 * s, { size: 46 * s, align: 'center', color: o.accent });
      text(ctx, 'Link en la bio', W / 2, H * .36 + 300 * s, { size: 32 * s, align: 'center', weight: 400 });
    }
    brand(ctx, W, H, D, o);
  } });

add({ id: 'carrusel-meses', nombre: 'Carrusel: mes por mes', tipo: 'carrusel', fmt: '4:5', dur: 0, cat: ['carrusel', 'timelapse'], slides: 6,
  desc: 'Una lámina por etapa, con fecha y día de obra.',
  titulo: '{obra}', sub: 'mes a mes',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(D.hist.concat([D.heroItem]), 6), i = o.slide ?? Math.floor(t / 1.4) % 6, f = fr[i], fe = f.fecha || D.hoyFecha;
    cover(ctx, f.src, 0, 0, W, H, 1.03); shade(ctx, W, H, .5, .85);
    text(ctx, MESES_L[+fe.split('-')[1] - 1].toUpperCase(), 60 * s, 60 * s, { size: 96 * s, color: o.accent, shadow: 1 });
    text(ctx, fe.split('-')[0], 60 * s, 170 * s, { size: 44 * s, weight: 500, shadow: 1 });
    for (let k = 0; k < 6; k++) { rr(ctx, 60 * s + k * 40 * s, H - 70 * s, 28 * s, 8 * s, 4 * s); ctx.fillStyle = k === i ? o.accent : 'rgba(255,255,255,.4)'; ctx.fill(); }
    text(ctx, o.titulo, 60 * s, H - 250 * s, { size: 64 * s, maxW: W - 120 * s, shadow: 1 });
    text(ctx, o.sub + ' · día ' + num(dayOf(D, fe)), 60 * s, H - 160 * s, { size: 32 * s, weight: 500 });
  } });

add({ id: 'pdf-reporte', nombre: 'Reporte mensual (PDF)', tipo: 'pdf', fmt: 'A4', dur: 0, cat: ['pdf'], slides: 2,
  desc: 'Dos páginas para mandar a compradores o inversores.',
  titulo: 'Reporte de avance', sub: '{mesAnioLargo}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1240, p = o.slide ?? Math.floor(t / 2.2) % 2;
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, H);
    const ink = '#101512', mut = '#5e6b64';
    if (p === 0) {
      cover(ctx, D.heroItem.src, 0, 0, W, H * .52, 1.02);
      ctx.fillStyle = o.accent; ctx.fillRect(0, H * .52, W, 14 * s);
      text(ctx, o.titulo.toUpperCase(), 90 * s, H * .52 + 80 * s, { size: 30 * s, color: mut, ls: 6 * s, weight: 600 });
      text(ctx, D.obra, 90 * s, H * .52 + 130 * s, { size: 96 * s, color: ink, maxW: W - 180 * s });
      text(ctx, D.cliente + ' · ' + D.lugar + ' · ' + o.sub, 90 * s, H * .52 + 260 * s, { size: 32 * s, color: mut, weight: 500, maxW: W - 180 * s });
      const kp = [[num(D.dias), 'días de obra'], ['+' + num(D.fotos), 'fotos tomadas'], [D.meses, 'de seguimiento']];
      kp.forEach(([v, l], i) => { const x = 90 * s + i * 360 * s, y = H * .52 + 380 * s; ctx.fillStyle = '#f1f4f2'; rr(ctx, x, y, 330 * s, 200 * s, 18 * s); ctx.fill(); text(ctx, v, x + 30 * s, y + 36 * s, { size: 64 * s, color: ink }); text(ctx, l, x + 30 * s, y + 124 * s, { size: 28 * s, color: mut, weight: 500 }); });
      text(ctx, 'Imágenes reales de la cámara Lisual instalada en obra.', 90 * s, H - 110 * s, { size: 24 * s, color: mut, weight: 400 });
    } else {
      text(ctx, 'Evolución', 90 * s, 80 * s, { size: 64 * s, color: ink });
      text(ctx, 'Una foto por etapa, del inicio a hoy', 90 * s, 170 * s, { size: 30 * s, color: mut, weight: 500 });
      const fr = pickN(D.hist.concat([D.heroItem]), 6), cw = (W - 180 * s - 30 * s) / 2, chh = 380 * s;
      fr.forEach((f, i) => { const x = 90 * s + (i % 2) * (cw + 30 * s), y = 250 * s + Math.floor(i / 2) * (chh + 90 * s); rr(ctx, x, y, cw, chh, 16 * s); ctx.save(); ctx.clip(); cover(ctx, f.src, x, y, cw, chh); ctx.restore(); text(ctx, f.fecha ? fdate(f.fecha, true) : 'Hoy', x, y + chh + 16 * s, { size: 28 * s, color: ink, weight: 600 }); });
      ctx.fillStyle = o.accent; ctx.fillRect(90 * s, H - 90 * s, 60 * s, 6 * s);
      text(ctx, 'Seguí la obra en vivo · ' + D.ig, 170 * s, H - 104 * s, { size: 26 * s, color: ink, weight: 600 });
    }
  } });

add({ id: 'pdf-ficha', nombre: 'Ficha para inversores (PDF)', tipo: 'pdf', fmt: 'A4', dur: 0, cat: ['pdf'], slides: 1,
  desc: 'Una página con la obra, las cifras y el antes y después.',
  titulo: 'Ficha de obra', sub: 'Actualizada al {hoyLargo}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1240, ink = '#f3f6f4', mut = '#9fb0a7';
    ctx.fillStyle = '#070B09'; ctx.fillRect(0, 0, W, H);
    text(ctx, o.titulo.toUpperCase(), 90 * s, 90 * s, { size: 28 * s, color: o.accent, ls: 6 * s, weight: 600 });
    text(ctx, D.obra, 90 * s, 140 * s, { size: 110 * s, color: ink, maxW: W - 180 * s });
    text(ctx, D.cliente + ' · ' + D.lugar, 90 * s, 280 * s, { size: 34 * s, color: mut, weight: 500 });
    const y = 380 * s, hw = (W - 180 * s - 20 * s) / 2, hh = 620 * s;
    rr(ctx, 90 * s, y, hw, hh, 18 * s); ctx.save(); ctx.clip(); cover(ctx, D.hist[0].src, 90 * s, y, hw, hh); ctx.restore();
    rr(ctx, 110 * s + hw, y, hw, hh, 18 * s); ctx.save(); ctx.clip(); cover(ctx, D.heroItem.src, 110 * s + hw, y, hw, hh); ctx.restore();
    pill(ctx, 'INICIO · ' + fdate(D.hist[0].fecha).toUpperCase(), 110 * s, y + 20 * s, { size: 22 * s });
    pill(ctx, 'HOY · ' + fdate(D.hoyFecha).toUpperCase(), 130 * s + hw, y + 20 * s, { size: 22 * s, bg: o.accent, color: '#06100b' });
    const kp = [[num(D.dias), 'días de obra'], ['+' + num(D.fotos), 'fotos'], [D.meses, 'de seguimiento']];
    kp.forEach(([v, l], i) => { const x = 90 * s + i * 360 * s, yy = y + hh + 80 * s; text(ctx, v, x, yy, { size: 80 * s, color: o.accent }); text(ctx, l, x, yy + 100 * s, { size: 30 * s, color: mut, weight: 500 }); });
    text(ctx, 'Cada foto de esta ficha salió de la cámara instalada en la obra. Podés ver el avance en vivo desde cualquier lugar.', 90 * s, H - 330 * s, { size: 34 * s, color: ink, weight: 400, maxW: W - 180 * s, lh: 1.35 });
    text(ctx, o.sub, 90 * s, H - 120 * s, { size: 26 * s, color: mut, weight: 500 });
    text(ctx, D.ig, W - 90 * s, H - 120 * s, { size: 26 * s, color: ink, weight: 600, align: 'right' });
  } });

add({ id: 'post-hoy', nombre: 'Foto del día', tipo: 'post', fmt: '4:5', dur: 0, cat: ['post'],
  desc: 'La mejor foto de hoy con un pie mínimo.',
  titulo: 'Hoy, {hoyCorto}', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    ctx.fillStyle = '#f4f3ef'; ctx.fillRect(0, 0, W, H);
    cover(ctx, D.heroItem.src, 50 * s, 50 * s, W - 100 * s, H - 280 * s);
    text(ctx, o.titulo, 50 * s, H - 200 * s, { size: 56 * s, color: '#101512' });
    text(ctx, o.sub + ' · ' + D.lugar, 50 * s, H - 118 * s, { size: 28 * s, color: '#5e6b64', weight: 500 });
    dot(ctx, W - 80 * s, H - 150 * s, 18 * s, o.accent);
  } });

// ───────── plantillas nuevas: avance de obra animado ─────────
const ETAPAS = [['Movimiento de suelo', 8], ['Fundaciones', 20], ['Estructura', 40], ['Cerramientos', 58], ['Instalaciones', 74], ['Terminaciones', 92]];
const ser = (D) => D.hist.concat([D.heroItem]);

add({ id: 'avance-barra', nombre: 'Avance de obra %', tipo: 'story', fmt: '9:16', dur: 7, cat: ['story', 'avance'], nuevo: 1, alta: '2026-10-02',
  desc: 'Barra que se llena y etapas que se van tildando.',
  titulo: 'Avance de obra', sub: '{obra}', numero: 60,
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, n = clamp(Number(o.numero) || 0, 0, 100), k = easeOut(seg(t, .6, 3.2)), pct = n * k;
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.05 + .05 * t / 7);
    shade(ctx, W, H, .55, .9); brand(ctx, W, H, D, o);
    text(ctx, o.titulo.toUpperCase(), 60 * s, 170 * s, { size: 34 * s, color: o.accent, ls: 6 * s, weight: 600 });
    text(ctx, o.sub, 60 * s, 220 * s, { size: 74 * s, maxW: W - 120 * s, shadow: 1 });
    const py = H - 900 * s;
    rr(ctx, 50 * s, py, W - 100 * s, 780 * s, 40 * s); ctx.fillStyle = 'rgba(8,14,11,.8)'; ctx.fill();
    text(ctx, Math.round(pct) + '%', 100 * s, py + 40 * s, { size: 190 * s, color: o.accent });
    text(ctx, 'completado', 100 * s, py + 250 * s, { size: 32 * s, weight: 500, color: 'rgba(255,255,255,.8)' });
    rr(ctx, 100 * s, py + 310 * s, W - 200 * s, 22 * s, 11 * s); ctx.fillStyle = 'rgba(255,255,255,.15)'; ctx.fill();
    rr(ctx, 100 * s, py + 310 * s, Math.max(22 * s, (W - 200 * s) * pct / 100), 22 * s, 11 * s); ctx.fillStyle = o.accent; ctx.fill();
    ETAPAS.forEach(([lbl, thr], i) => {
      const a = easeOut(seg(t, 1.2 + i * .4, 1.6 + i * .4)); if (a <= 0) return;
      const y = py + 380 * s + i * 62 * s, done = pct >= thr;
      ctx.globalAlpha = a;
      if (done) { dot(ctx, 120 * s, y + 20 * s, 18 * s, o.accent); text(ctx, '✓', 120 * s, y + 4 * s, { size: 26 * s, align: 'center', color: '#06100b' }); }
      else { ctx.strokeStyle = 'rgba(255,255,255,.45)'; ctx.lineWidth = 3 * s; ctx.beginPath(); ctx.arc(120 * s, y + 20 * s, 16 * s, 0, Math.PI * 2); ctx.stroke(); }
      text(ctx, lbl, 160 * s, y + 2 * s, { size: 32 * s, weight: done ? 600 : 400, color: done ? '#fff' : 'rgba(255,255,255,.6)' });
      ctx.globalAlpha = 1;
    });
  } });

add({ id: 'escaneo', nombre: 'Escaneo de avance', tipo: 'reel', fmt: '9:16', dur: 6, cat: ['reel', 'avance'], nuevo: 1, alta: '2026-10-02', trend: 1,
  desc: 'Una línea láser recorre la obra y revela cómo está hoy.',
  titulo: 'Así cambió en {meses}', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, y = H * easeInOut(seg(t, .7, 4.2));
    ctx.filter = 'grayscale(1) brightness(.7)'; cover(ctx, D.hist[0].src, 0, 0, W, H, 1.06); ctx.filter = 'none';
    ctx.save(); ctx.beginPath(); ctx.rect(0, 0, W, y); ctx.clip(); cover(ctx, D.heroItem.src, 0, 0, W, H, 1.06); ctx.restore();
    ctx.strokeStyle = 'rgba(255,255,255,.08)'; ctx.lineWidth = 1;
    for (let gx = 0; gx < W; gx += 90 * s) { ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H); ctx.stroke(); }
    for (let gy = 0; gy < H; gy += 90 * s) { ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke(); }
    if (y > 0 && y < H) {
      const g = ctx.createLinearGradient(0, y - 120 * s, 0, y); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, o.accent + '66'); ctx.fillStyle = g; ctx.fillRect(0, y - 120 * s, W, 120 * s);
      ctx.save(); ctx.shadowColor = o.accent; ctx.shadowBlur = 30 * s; ctx.fillStyle = o.accent; ctx.fillRect(0, y - 3 * s, W, 6 * s); ctx.restore();
      pill(ctx, 'ESCANEANDO ' + Math.round(y / H * 100) + '%', W - 50 * s, y + 20 * s, { size: 24 * s, align: 'right', bg: o.accent, color: '#06100b', ls: 2 * s });
    }
    ctx.font = font(24 * s, 600, 'JetBrains Mono'); ctx.fillStyle = 'rgba(255,255,255,.85)'; ctx.textAlign = 'left'; ctx.textBaseline = 'top';
    ctx.fillText('ANÁLISIS DE AVANCE', 50 * s, 160 * s); ctx.fillText(fdate(D.hist[0].fecha).toUpperCase() + ' → ' + fdate(D.hoyFecha).toUpperCase(), 50 * s, 196 * s);
    brand(ctx, W, H, D, o);
    const a = easeOut(seg(t, 4.3, 5));
    if (a > 0) {
      ctx.globalAlpha = a; ctx.fillStyle = 'rgba(0,0,0,.35)'; ctx.fillRect(0, 0, W, H);
      text(ctx, o.titulo, W / 2, H * .4 + (1 - a) * 40 * s, { size: 92 * s, align: 'center', maxW: W - 140 * s, shadow: 1 });
      text(ctx, o.sub, W / 2, H * .4 + 230 * s, { size: 40 * s, align: 'center', weight: 500, color: o.accent }); ctx.globalAlpha = 1;
    }
  } });

add({ id: 'zoom-detalle', nombre: 'Zoom a los detalles', tipo: 'story', fmt: '9:16', dur: 8, cat: ['story', 'avance'], nuevo: 1, alta: '2026-10-02',
  desc: 'La cámara se acerca a tres sectores de la obra.',
  titulo: 'Los detalles de {obra}', sub: 'Cada sector, en foco',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, pts = [[.3, .42, 'Estructura'], [.72, .5, 'Fachada'], [.5, .72, 'Planta baja']];
    const per = 2.2, i = Math.min(2, Math.floor(t / per)), p = clamp((t - i * per) / per), bell = Math.sin(Math.PI * p);
    const [fx, fy, lbl] = pts[i];
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.05 + .9 * easeInOut(bell), fx, fy);
    shade(ctx, W, H, .45, .7); brand(ctx, W, H, D, o);
    if (bell > .5) {
      const a = (bell - .5) * 2, r = 120 * s + 30 * s * Math.sin(t * 6);
      ctx.globalAlpha = a; ctx.strokeStyle = o.accent; ctx.lineWidth = 6 * s; ctx.beginPath(); ctx.arc(W / 2, H / 2, r, 0, Math.PI * 2); ctx.stroke();
      pill(ctx, lbl.toUpperCase(), W / 2, H / 2 + r + 30 * s, { size: 32 * s, align: 'center', bg: o.accent, color: '#06100b', ls: 3 * s }); ctx.globalAlpha = 1;
    }
    text(ctx, (i + 1) + ' / 3', W - 60 * s, 170 * s, { size: 30 * s, align: 'right', weight: 600 });
    text(ctx, o.titulo, 60 * s, H - 330 * s, { size: 66 * s, maxW: W - 120 * s, shadow: 1 });
    text(ctx, o.sub, 60 * s, H - 160 * s, { size: 32 * s, weight: 500, color: 'rgba(255,255,255,.85)' });
  } });

add({ id: 'linea-tiempo', nombre: 'Línea de tiempo animada', tipo: 'reel', fmt: '9:16', dur: 9, cat: ['reel', 'timelapse', 'avance'], nuevo: 1, alta: '2026-10-02',
  desc: 'Un cursor recorre los meses y la foto cambia con él.',
  titulo: 'Mes a mes, {obra}', sub: '{lugar}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(ser(D), 10), n = fr.length, pos = clamp(t / (this.dur * .9)) * (n - 1), i = Math.floor(pos), f = pos - i;
    cover(ctx, fr[i].src, 0, 0, W, H, 1.05);
    if (i + 1 < n && f > .55) { ctx.globalAlpha = (f - .55) / .45; cover(ctx, fr[i + 1].src, 0, 0, W, H, 1.05); ctx.globalAlpha = 1; }
    shade(ctx, W, H, .5, .9); brand(ctx, W, H, D, o);
    text(ctx, o.titulo, 60 * s, 170 * s, { size: 74 * s, maxW: W - 120 * s, shadow: 1 });
    const cur = fr[Math.round(pos)], fe = cur.fecha || D.hoyFecha;
    const pop = 1 + .15 * Math.max(0, 1 - Math.abs(f - (Math.round(pos) - i)) * 4);
    ctx.save(); ctx.translate(60 * s, H - 520 * s); ctx.scale(pop, pop);
    text(ctx, MESES_L[+fe.split('-')[1] - 1].toUpperCase(), 0, 0, { size: 110 * s, color: o.accent, shadow: 1 });
    ctx.restore();
    text(ctx, fe.split('-')[0] + ' · día ' + num(dayOf(D, fe)), 60 * s, H - 390 * s, { size: 36 * s, weight: 500 });
    const x0 = 80 * s, x1 = W - 80 * s, ly = H - 250 * s;
    ctx.strokeStyle = 'rgba(255,255,255,.35)'; ctx.lineWidth = 4 * s; ctx.beginPath(); ctx.moveTo(x0, ly); ctx.lineTo(x1, ly); ctx.stroke();
    const px = x0 + (x1 - x0) * pos / (n - 1);
    ctx.strokeStyle = o.accent; ctx.beginPath(); ctx.moveTo(x0, ly); ctx.lineTo(px, ly); ctx.stroke();
    fr.forEach((_, k) => dot(ctx, x0 + (x1 - x0) * k / (n - 1), ly, 9 * s, k <= pos ? o.accent : 'rgba(255,255,255,.5)'));
    dot(ctx, px, ly, 20 * s, '#fff'); dot(ctx, px, ly, 12 * s, o.accent);
    text(ctx, fmes(fr[0].fecha).toUpperCase(), x0, ly + 30 * s, { size: 22 * s, weight: 600 });
    text(ctx, 'HOY', x1, ly + 30 * s, { size: 22 * s, weight: 600, align: 'right' });
  } });

add({ id: 'ida-vuelta', nombre: 'Comparador ida y vuelta', tipo: 'reel', fmt: '9:16', dur: 8, cat: ['reel', 'avance'], nuevo: 1, alta: '2026-10-02',
  desc: 'La cortina va y viene entre el primer día y hoy.',
  titulo: 'Antes ↔ Hoy', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, x = W * (.5 + .42 * Math.sin(t * 1.3));
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.05);
    ctx.save(); ctx.beginPath(); ctx.rect(0, 0, x, H); ctx.clip(); cover(ctx, D.hist[0].src, 0, 0, W, H, 1.05); ctx.restore();
    shade(ctx, W, H, .45, .7);
    ctx.save(); ctx.shadowColor = 'rgba(0,0,0,.5)'; ctx.shadowBlur = 20 * s; ctx.fillStyle = '#fff'; ctx.fillRect(x - 4 * s, 0, 8 * s, H); ctx.restore();
    dot(ctx, x, H * .5, 44 * s, '#fff'); text(ctx, '⇆', x, H * .5 - 28 * s, { size: 48 * s, align: 'center', color: '#111' });
    pill(ctx, 'ANTES', 50 * s, H * .5 - 120 * s, { size: 28 * s, ls: 3 * s });
    pill(ctx, 'HOY', W - 50 * s, H * .5 - 120 * s, { size: 28 * s, align: 'right', bg: o.accent, color: '#06100b', ls: 3 * s });
    brand(ctx, W, H, D, o);
    text(ctx, o.titulo, W / 2, 180 * s, { size: 86 * s, align: 'center', shadow: 1 });
    text(ctx, o.sub, W / 2, 290 * s, { size: 36 * s, align: 'center', weight: 500, shadow: 1 });
    text(ctx, 'Día 1  →  Día ' + num(D.dias), W / 2, H - 200 * s, { size: 44 * s, align: 'center', color: o.accent, shadow: 1 });
  } });

add({ id: 'mosaico-revela', nombre: 'Mosaico que se arma', tipo: 'story', fmt: '9:16', dur: 6, cat: ['story', 'avance'], nuevo: 1, alta: '2026-10-02', trend: 1,
  desc: 'La foto de hoy se arma pieza por pieza, como la obra.',
  titulo: 'Pieza por pieza', sub: 'Así se construye {obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, cols = 6, rows = 10, cw = W / cols, ch = H / rows;
    ctx.fillStyle = '#070B09'; ctx.fillRect(0, 0, W, H);
    for (let r = 0; r < rows; r++) for (let c = 0; c < cols; c++) {
      const idx = r * cols + c, delay = .2 + ((idx * 37) % 60) / 60 * 2.6 + (rows - r) * .04;
      const k = easeOut(seg(t, delay, delay + .45)); if (k <= 0) continue;
      ctx.save(); ctx.beginPath();
      const w = cw * k, x = c * cw + (cw - w) / 2;
      ctx.rect(x, r * ch, w, ch); ctx.clip();
      cover(ctx, D.heroItem.src, 0, 0, W, H, 1.02); ctx.restore();
      if (k < 1) { ctx.fillStyle = o.accent; ctx.globalAlpha = (1 - k) * .7; ctx.fillRect(x, r * ch, w, ch); ctx.globalAlpha = 1; }
    }
    const a = easeOut(seg(t, 3.6, 4.4));
    if (a > 0) {
      ctx.globalAlpha = a; shade(ctx, W, H, .2, .85); brand(ctx, W, H, D, o);
      ctx.fillStyle = o.accent; ctx.fillRect(60 * s, H - 470 * s, 110 * s, 8 * s);
      text(ctx, o.titulo, 60 * s, H - 440 * s, { size: 100 * s, maxW: W - 120 * s, shadow: 1 });
      text(ctx, o.sub, 60 * s, H - 200 * s, { size: 38 * s, weight: 500, maxW: W - 120 * s }); ctx.globalAlpha = 1;
    }
  } });

add({ id: 'plano-obra', nombre: 'Del plano a la obra', tipo: 'reel', fmt: '9:16', dur: 7, cat: ['reel', 'avance'], nuevo: 1, alta: '2026-10-02', trend: 1,
  desc: 'La foto arranca como plano azul y se vuelve real.',
  titulo: 'Del plano a la obra', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, z = 1.04 + .04 * t / 7;
    ctx.fillStyle = '#0d3b78'; ctx.fillRect(0, 0, W, H);
    ctx.filter = 'grayscale(1) invert(1) contrast(1.9) brightness(1.1)'; ctx.globalCompositeOperation = 'screen'; ctx.globalAlpha = .55;
    cover(ctx, D.heroItem.src, 0, 0, W, H, z); ctx.filter = 'none'; ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
    ctx.strokeStyle = 'rgba(255,255,255,.12)'; ctx.lineWidth = 1;
    for (let gx = 0; gx < W; gx += 54 * s) { ctx.beginPath(); ctx.moveTo(gx, 0); ctx.lineTo(gx, H); ctx.stroke(); }
    for (let gy = 0; gy < H; gy += 54 * s) { ctx.beginPath(); ctx.moveTo(0, gy); ctx.lineTo(W, gy); ctx.stroke(); }
    const p = easeInOut(seg(t, 2.3, 4.6));
    if (p > 0) {
      const d = (W + H) * p;
      ctx.save(); ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(d, 0); ctx.lineTo(0, d); ctx.closePath(); ctx.clip(); cover(ctx, D.heroItem.src, 0, 0, W, H, z); ctx.restore();
      if (p < 1) { ctx.save(); ctx.strokeStyle = '#fff'; ctx.shadowColor = o.accent; ctx.shadowBlur = 25 * s; ctx.lineWidth = 6 * s; ctx.beginPath(); ctx.moveTo(d, 0); ctx.lineTo(0, d); ctx.stroke(); ctx.restore(); }
    }
    ctx.font = font(26 * s, 600, 'JetBrains Mono'); ctx.fillStyle = '#fff'; ctx.textAlign = 'left'; ctx.textBaseline = 'top';
    if (p < .5) { ctx.fillText('PLANO · ESC 1:100', 50 * s, 160 * s); ctx.fillText(D.obra.toUpperCase(), 50 * s, 200 * s); }
    brand(ctx, W, H, D, o);
    const a = easeOut(seg(t, 4.8, 5.6));
    if (a > 0) { ctx.globalAlpha = a; shade(ctx, W, H, .1, .85); text(ctx, o.titulo, 60 * s, H - 420 * s, { size: 92 * s, maxW: W - 120 * s, shadow: 1 }); text(ctx, o.sub, 60 * s, H - 200 * s, { size: 38 * s, weight: 500, color: o.accent }); ctx.globalAlpha = 1; }
  } });

add({ id: 'hitos', nombre: 'Hitos de la obra', tipo: 'story', fmt: '9:16', dur: 7, cat: ['story', 'avance'], nuevo: 1, alta: '2026-10-02',
  desc: 'Una línea que se dibuja y va mostrando cada hito.',
  titulo: 'Nuestros hitos', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(ser(D), 4), top = 330 * s, bot = H - 180 * s, lx = W / 2;
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.2); ctx.fillStyle = 'rgba(7,11,9,.86)'; ctx.fillRect(0, 0, W, H);
    text(ctx, o.titulo, W / 2, 120 * s, { size: 72 * s, align: 'center' });
    text(ctx, o.sub, W / 2, 210 * s, { size: 32 * s, align: 'center', weight: 500, color: o.accent });
    const p = easeInOut(seg(t, .4, 5.2)), ly = top + (bot - top) * p;
    ctx.strokeStyle = 'rgba(255,255,255,.15)'; ctx.lineWidth = 6 * s; ctx.beginPath(); ctx.moveTo(lx, top); ctx.lineTo(lx, bot); ctx.stroke();
    ctx.strokeStyle = o.accent; ctx.beginPath(); ctx.moveTo(lx, top); ctx.lineTo(lx, ly); ctx.stroke();
    const labels = ['Arranque', 'Primer avance', 'Obra en marcha', 'Hoy'];
    fr.forEach((f, i) => {
      const y = top + (bot - top) * (i / (fr.length - 1 || 1)), k = easeOut(seg(ly, y - 1, y + 140 * s)); if (k <= 0) return;
      const left = i % 2 === 0, r = 120 * s * k, cx = left ? lx - 230 * s : lx + 230 * s;
      dot(ctx, lx, y, 16 * s, o.accent);
      ctx.save(); ctx.beginPath(); ctx.arc(cx, y, r, 0, Math.PI * 2); ctx.clip(); cover(ctx, f.src, cx - r, y - r, r * 2, r * 2); ctx.restore();
      ctx.strokeStyle = o.accent; ctx.lineWidth = 5 * s; ctx.beginPath(); ctx.arc(cx, y, r, 0, Math.PI * 2); ctx.stroke();
      ctx.globalAlpha = k;
      const tx = left ? lx + 40 * s : lx - 40 * s, al = left ? 'left' : 'right';
      text(ctx, labels[i], tx, y - 44 * s, { size: 36 * s, align: al });
      text(ctx, fdate(f.fecha || D.hoyFecha), tx, y + 2 * s, { size: 28 * s, align: al, weight: 500, color: 'rgba(255,255,255,.7)' });
      ctx.globalAlpha = 1;
    });
    brand(ctx, W, H, D, Object.assign({}, o, { chip: false }));
  } });

add({ id: 'boomerang', nombre: 'Boomerang de obra', tipo: 'reel', fmt: '9:16', dur: 6, cat: ['reel', 'timelapse', 'avance'], nuevo: 1, alta: '2026-10-02',
  desc: 'La obra avanza y retrocede a toda velocidad.',
  titulo: '{dias} días', sub: 'ida y vuelta',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(ser(D), 14), n = fr.length, p = t / this.dur, pos = p < .5 ? easeInOut(p * 2) : easeInOut(2 - p * 2);
    const i = Math.round(pos * (n - 1));
    cover(ctx, fr[i].src, 0, 0, W, H, 1.08 - .04 * pos);
    const v = ctx.createRadialGradient(W / 2, H / 2, W * .3, W / 2, H / 2, H * .7); v.addColorStop(0, 'rgba(0,0,0,0)'); v.addColorStop(1, 'rgba(0,0,0,.7)'); ctx.fillStyle = v; ctx.fillRect(0, 0, W, H);
    brand(ctx, W, H, D, o);
    const fwd = p < .5, speed = Math.round(200 + 1800 * Math.sin(Math.PI * (fwd ? p * 2 : 2 - p * 2)));
    pill(ctx, (fwd ? '▶▶ ' : '◀◀ ') + 'x' + speed, W / 2, H * .16, { size: 40 * s, align: 'center', bg: fwd ? o.accent : '#fff', color: '#06100b', ls: 2 * s });
    text(ctx, fmes(fr[i].fecha || D.hoyFecha).toUpperCase(), W / 2, H * .5 - 60 * s, { size: 120 * s, align: 'center', shadow: 1 });
    text(ctx, o.titulo, W / 2, H - 330 * s, { size: 90 * s, align: 'center', color: o.accent, shadow: 1 });
    text(ctx, o.sub, W / 2, H - 210 * s, { size: 40 * s, align: 'center', weight: 500, shadow: 1 });
  } });

add({ id: 'noticiero', nombre: 'Noticiero de obra', tipo: 'story', fmt: '9:16', dur: 8, cat: ['story', 'avance'], nuevo: 1, alta: '2026-10-02', trend: 1,
  desc: 'Formato de noticia en vivo con titular y zócalo que corre.',
  titulo: 'Avanza a buen ritmo {obra}', sub: 'ÚLTIMO MOMENTO',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.04 + .08 * t / 8, .5, .45);
    shade(ctx, W, H, .4, .7);
    const blink = Math.sin(t * 6) > 0;
    pill(ctx, (blink ? '● ' : '○ ') + 'EN VIVO', 50 * s, 70 * s, { size: 30 * s, bg: '#e11d2a', ls: 3 * s });
    text(ctx, D.heroItem.hora || '', 50 * s + 230 * s, 80 * s, { size: 32 * s, weight: 600, shadow: 1 });
    const a = easeOut(seg(t, .4, 1.1)), by = H - 520 * s;
    ctx.save(); ctx.translate(-(1 - a) * W, 0);
    ctx.fillStyle = o.accent; ctx.fillRect(0, by, 360 * s, 70 * s);
    text(ctx, o.sub.toUpperCase(), 30 * s, by + 16 * s, { size: 32 * s, color: '#06100b', ls: 2 * s });
    ctx.fillStyle = 'rgba(255,255,255,.96)'; ctx.fillRect(0, by + 70 * s, W, 230 * s);
    text(ctx, o.titulo, 30 * s, by + 96 * s, { size: 56 * s, color: '#101512', maxW: W - 60 * s });
    ctx.restore();
    const ty = H - 210 * s; ctx.fillStyle = '#101512'; ctx.fillRect(0, ty, W, 80 * s);
    const tick = `${D.obra} · ${D.lugar ? D.lugar + ' · ' : ''}${num(D.dias)} días de obra · +${num(D.fotos)} fotos · Seguí la obra en vivo · `;
    ctx.font = font(34 * s, 600); const tw = ctx.measureText(tick).width, off = (t * 180 * s) % tw;
    ctx.save(); ctx.beginPath(); ctx.rect(0, ty, W, 80 * s); ctx.clip();
    ctx.fillStyle = '#fff'; ctx.textBaseline = 'middle'; ctx.textAlign = 'left';
    for (let x = -off; x < W; x += tw) ctx.fillText(tick, x, ty + 42 * s);
    ctx.restore();
    brand(ctx, W, H, D, Object.assign({}, o, { chip: false }), { markY: H - 60 * s });
  } });

add({ id: 'calendario', nombre: 'Calendario de obra', tipo: 'reel', fmt: '9:16', dur: 7, cat: ['reel', 'avance', 'timelapse'], nuevo: 1, alta: '2026-10-02',
  desc: 'Las hojas del calendario pasan y la obra crece en cada una.',
  titulo: '{meses} de obra', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, fr = pickN(ser(D), 9), n = fr.length, per = this.dur * .85 / n, i = Math.min(n - 1, Math.floor(t / per)), f = clamp((t - i * per) / per);
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.3); ctx.fillStyle = 'rgba(7,11,9,.82)'; ctx.fillRect(0, 0, W, H);
    text(ctx, o.titulo, W / 2, 140 * s, { size: 84 * s, align: 'center', color: o.accent });
    text(ctx, o.sub, W / 2, 250 * s, { size: 36 * s, align: 'center', weight: 500 });
    const cw = 820 * s, chh = 1060 * s, cx = (W - cw) / 2, cy = 380 * s;
    const page = (fItem, scaleY) => {
      const fe = fItem.fecha || D.hoyFecha;
      ctx.save(); ctx.translate(0, cy); ctx.scale(1, scaleY); ctx.translate(0, -cy);
      rr(ctx, cx, cy, cw, chh, 30 * s); ctx.fillStyle = '#f7f6f2'; ctx.fill();
      ctx.fillStyle = o.accent; rr(ctx, cx, cy, cw, 160 * s, 30 * s); ctx.fill(); ctx.fillRect(cx, cy + 120 * s, cw, 40 * s);
      text(ctx, MESES_L[+fe.split('-')[1] - 1].toUpperCase() + ' ' + fe.split('-')[0], W / 2, cy + 50 * s, { size: 56 * s, align: 'center', color: '#06100b' });
      cover(ctx, fItem.src, cx + 40 * s, cy + 200 * s, cw - 80 * s, 640 * s);
      text(ctx, 'Día ' + num(dayOf(D, fe)), W / 2, cy + 880 * s, { size: 64 * s, align: 'center', color: '#101512' });
      ctx.restore();
      for (let k = 0; k < 6; k++) { dot(ctx, cx + 120 * s + k * 116 * s, cy, 14 * s, '#cfd4d1'); }
    };
    if (i + 1 < n) page(fr[i + 1], 1);
    const flip = f > .7 && i + 1 < n ? Math.cos(Math.PI / 2 * (f - .7) / .3) : 1;
    page(fr[i], Math.max(.001, flip));
    brand(ctx, W, H, D, Object.assign({}, o, { chip: false }));
  } });

// ───────── PDF y piezas con datos de la IA de obra (personas, casco, máquinas) ─────────
const hasIA = (D) => !!(D.ia && D.ia.dias && D.ia.dias.length);
const diaCorto = (iso) => { const [, m, d] = iso.split('-').map(Number); return `${d}/${m}`; };
function bars(ctx, x, y, w, h, vals, labels, o) {
  const s = o.s, max = Math.max(1, ...vals), n = Math.max(1, vals.length), slot = w / n, bw = slot * .62;
  ctx.strokeStyle = o.grid || '#e3e8e5'; ctx.lineWidth = 2 * s;
  for (let k = 0; k <= 4; k++) { const yy = y + h - h * k / 4; ctx.beginPath(); ctx.moveTo(x, yy); ctx.lineTo(x + w, yy); ctx.stroke(); }
  vals.forEach((v, i) => {
    const bh = h * v / max, bx = x + i * slot + (slot - bw) / 2;
    rr(ctx, bx, y + h - Math.max(bh, 3 * s), bw, Math.max(bh, 3 * s), Math.min(10 * s, bw / 3)); ctx.fillStyle = o.color; ctx.fill();
    if (v > 0) text(ctx, String(Math.round(v)), bx + bw / 2, y + h - bh - 34 * s, { size: 22 * s, align: 'center', color: o.ink, weight: 600 });
    if (labels[i]) text(ctx, labels[i], bx + bw / 2, y + h + 12 * s, { size: 20 * s, align: 'center', color: o.mut, weight: 500 });
  });
}
function kpi(ctx, x, y, w, v, l, o) {
  const s = o.s; rr(ctx, x, y, w, 190 * s, 18 * s); ctx.fillStyle = o.card; ctx.fill();
  text(ctx, v, x + 28 * s, y + 30 * s, { size: 62 * s, color: o.accentInk || o.ink });
  text(ctx, l, x + 28 * s, y + 118 * s, { size: 24 * s, color: o.mut, weight: 500, maxW: w - 50 * s });
}
function iaResumen(D) {
  const d = D.ia.dias, act = d.filter((x) => x.max > 0);
  const prom = act.length ? act.reduce((a, b) => a + b.max, 0) / act.length : 0;
  const pico = d.reduce((a, b) => (b.max > (a ? a.max : -1) ? b : a), null);
  const pers = act.reduce((a, b) => a + b.max, 0), conCasco = act.reduce((a, b) => a + b.casco, 0);
  return { d, act, prom, pico, pctCasco: pers ? Math.round(conCasco / pers * 100) : null, maq: d.filter((x) => x.excavadoras > 0).length, vehic: d.reduce((a, b) => a + b.autos + b.camionetas, 0) };
}
const LIGHT = (s, o) => ({ s, ink: '#101512', mut: '#5e6b64', card: '#f1f4f2', grid: '#e3e8e5', color: o.accent, accentInk: '#101512' });

add({ id: 'pdf-personal', nombre: 'Reporte de personal en obra (PDF)', tipo: 'pdf', fmt: 'A4', dur: 0, cat: ['pdf', 'avance'], slides: 2, requires: 'ia', nuevo: 1, alta: '2026-10-02',
  desc: 'Cuánta gente trabajó cada día, con pico, promedio y horarios.',
  titulo: 'Personal en obra', sub: 'Últimos {iaDias} días',
  render(ctx, W, H, t, D, o) {
    const s = W / 1240, p = o.slide ?? Math.floor(t / 2.4) % 2, L = LIGHT(s, o);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H);
    if (!hasIA(D)) { text(ctx, 'Sin datos de IA para esta cámara', 90 * s, 120 * s, { size: 40 * s, color: L.ink }); return; }
    const R = iaResumen(D);
    if (p === 0) {
      cover(ctx, D.heroItem.src, 0, 0, W, H * .4, 1.02);
      ctx.fillStyle = o.accent; ctx.fillRect(0, H * .4, W, 12 * s);
      text(ctx, 'REPORTE DE IA · ' + fill(o.sub, D).toUpperCase(), 90 * s, H * .4 + 60 * s, { size: 26 * s, color: L.mut, ls: 4 * s, weight: 600 });
      text(ctx, o.titulo, 90 * s, H * .4 + 105 * s, { size: 84 * s, color: L.ink });
      text(ctx, D.obra + ' · ' + D.cliente, 90 * s, H * .4 + 215 * s, { size: 30 * s, color: L.mut, weight: 500 });
      const kw = (W - 180 * s - 60 * s) / 3, ky = H * .4 + 300 * s;
      kpi(ctx, 90 * s, ky, kw, num(R.prom), 'personas por día (promedio)', L);
      kpi(ctx, 120 * s + kw, ky, kw, R.pico ? num(R.pico.max) : '-', 'pico' + (R.pico ? ' · ' + diaCorto(R.pico.fecha) : ''), L);
      kpi(ctx, 150 * s + kw * 2, ky, kw, String(R.act.length), 'días con actividad', L);
      text(ctx, 'Personas por día', 90 * s, ky + 250 * s, { size: 34 * s, color: L.ink });
      bars(ctx, 90 * s, ky + 320 * s, W - 180 * s, 250 * s, R.d.map((x) => x.max), R.d.map((x) => diaCorto(x.fecha)), L);
      text(ctx, 'Conteo automático de la cámara Lisual con inteligencia artificial.', 90 * s, H - 90 * s, { size: 22 * s, color: L.mut, weight: 400 });
    } else {
      text(ctx, 'Detalle por día', 90 * s, 80 * s, { size: 60 * s, color: L.ink });
      const cols = [['Día', 0], ['Personas (máx.)', 300], ['Con casco', 560], ['Primera', 780], ['Última', 960]];
      const y0 = 200 * s, rh = 66 * s;
      rr(ctx, 70 * s, y0, W - 140 * s, rh, 12 * s); ctx.fillStyle = o.accent; ctx.fill();
      cols.forEach(([l, x]) => text(ctx, l, 100 * s + x * s, y0 + 18 * s, { size: 24 * s, color: '#06100b', weight: 700 }));
      R.d.slice(-16).forEach((d, i) => {
        const y = y0 + rh * (i + 1);
        if (i % 2) { ctx.fillStyle = '#f5f7f6'; ctx.fillRect(70 * s, y, W - 140 * s, rh); }
        const vals = [diaCorto(d.fecha), String(d.max), d.max ? d.casco + ' (' + Math.round(d.casco / d.max * 100) + '%)' : '-', d.primera || '-', d.ultima || '-'];
        cols.forEach(([, x], k) => text(ctx, vals[k], 100 * s + x * s, y + 18 * s, { size: 26 * s, color: L.ink, weight: k ? 500 : 600 }));
      });
      text(ctx, 'Seguí la obra en vivo · ' + (D.ig || 'pro.lisual.com'), 90 * s, H - 100 * s, { size: 24 * s, color: L.ink, weight: 600 });
    }
  } });

add({ id: 'pdf-seguridad', nombre: 'Informe de seguridad (PDF)', tipo: 'pdf', fmt: 'A4', dur: 0, cat: ['pdf', 'avance'], slides: 1, requires: 'ia', nuevo: 1, alta: '2026-10-02',
  desc: 'Uso de casco por día y nivel de cumplimiento.',
  titulo: 'Informe de seguridad', sub: '{obra}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1240, L = LIGHT(s, o);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H);
    if (!hasIA(D)) return;
    const R = iaResumen(D), pct = R.pctCasco ?? 0, estado = pct >= 90 ? ['Óptimo', '#1d9a5b'] : pct >= 70 ? ['A mejorar', '#d18b00'] : ['Atención', '#d33a2c'];
    ctx.fillStyle = '#101512'; ctx.fillRect(0, 0, W, 330 * s);
    text(ctx, o.titulo.toUpperCase(), 90 * s, 80 * s, { size: 28 * s, color: o.accent, ls: 5 * s, weight: 700 });
    text(ctx, o.sub, 90 * s, 130 * s, { size: 72 * s, color: '#fff', maxW: W - 500 * s });
    const cx = W - 230 * s, cy = 165 * s, r = 110 * s;
    ctx.lineWidth = 26 * s; ctx.strokeStyle = 'rgba(255,255,255,.15)'; ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke();
    ctx.strokeStyle = estado[1]; ctx.beginPath(); ctx.arc(cx, cy, r, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * pct / 100); ctx.stroke();
    text(ctx, pct + '%', cx, cy - 42 * s, { size: 64 * s, align: 'center', color: '#fff' });
    text(ctx, 'con casco', cx, cy + 30 * s, { size: 22 * s, align: 'center', color: 'rgba(255,255,255,.7)', weight: 500 });
    pill(ctx, 'ESTADO: ' + estado[0].toUpperCase(), 90 * s, 400 * s, { size: 28 * s, bg: estado[1], ls: 2 * s });
    text(ctx, 'Personas con casco sobre el total, por día', 90 * s, 500 * s, { size: 32 * s, color: L.ink });
    const act = R.d.filter((x) => x.max > 0).slice(-14);
    bars(ctx, 90 * s, 580 * s, W - 180 * s, 420 * s, act.map((x) => Math.round(x.casco / x.max * 100)), act.map((x) => diaCorto(x.fecha)), Object.assign({}, L, { color: estado[1] }));
    const kw = (W - 180 * s - 40 * s) / 2;
    kpi(ctx, 90 * s, 1110 * s, kw, num(R.prom), 'personas por día en promedio', L);
    kpi(ctx, 130 * s + kw, 1110 * s, kw, num(R.maq), 'días con excavadoras en obra', L);
    text(ctx, 'Datos de la cámara Lisual analizados con inteligencia artificial. Sirve para seguir el uso de elementos de protección día a día.', 90 * s, 1380 * s, { size: 26 * s, color: L.mut, weight: 400, maxW: W - 180 * s, lh: 1.35 });
    cover(ctx, D.heroItem.src, 90 * s, 1490 * s, W - 180 * s, 180 * s, 1.2);
  } });

add({ id: 'pdf-parte-diario', nombre: 'Parte diario de obra (PDF)', tipo: 'pdf', fmt: 'A4', dur: 0, cat: ['pdf'], slides: 1, requires: 'ia', nuevo: 1, alta: '2026-10-02',
  desc: 'Una hoja con la foto del día, gente hora por hora, clima y máquinas.',
  titulo: 'Parte diario', sub: '{iaUltimoLargo}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1240, L = LIGHT(s, o);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H);
    if (!hasIA(D)) return;
    const d = D.ia.dias.slice().reverse().find((x) => x.max > 0) || D.ia.dias[D.ia.dias.length - 1];
    text(ctx, o.titulo.toUpperCase(), 90 * s, 80 * s, { size: 28 * s, color: L.mut, ls: 5 * s, weight: 700 });
    text(ctx, D.obra, 90 * s, 125 * s, { size: 76 * s, color: L.ink, maxW: W - 180 * s });
    text(ctx, fill(o.sub, D), 90 * s, 225 * s, { size: 30 * s, color: o.accent === '#E8E4DA' ? L.ink : o.accent, weight: 600 });
    cover(ctx, D.heroItem.src, 90 * s, 300 * s, W - 180 * s, 600 * s);
    const kw = (W - 180 * s - 60 * s) / 4, ky = 940 * s, c = D.clima;
    kpi(ctx, 90 * s, ky, kw, String(d.max), 'personas (máx.)', L);
    kpi(ctx, 110 * s + kw, ky, kw, d.primera || '-', 'primera detección', L);
    kpi(ctx, 130 * s + kw * 2, ky, kw, d.ultima || '-', 'última detección', L);
    kpi(ctx, 150 * s + kw * 3, ky, kw, c ? Math.round(c.temp) + '°' : '-', c ? c.desc : 'clima', L);
    text(ctx, 'Personas hora por hora', 90 * s, 1180 * s, { size: 32 * s, color: L.ink });
    const hs = []; for (let h = 7; h <= 19; h++) hs.push(h);
    bars(ctx, 90 * s, 1250 * s, W - 180 * s, 300 * s, hs.map((h) => d.horas[h] || 0), hs.map((h) => h + 'h'), L);
    text(ctx, `Vehículos: ${d.autos + d.camionetas} · Excavadoras: ${d.excavadoras}`, 90 * s, H - 100 * s, { size: 26 * s, color: L.ink, weight: 600 });
  } });

add({ id: 'pdf-evolucion', nombre: 'Evolución mes a mes (PDF)', tipo: 'pdf', fmt: 'A4', dur: 0, cat: ['pdf', 'avance'], slides: 3, nuevo: 1, alta: '2026-10-02',
  desc: 'Tres páginas: portada y doce fotos ordenadas en el tiempo.',
  titulo: 'Evolución de obra', sub: '{inicioLargo} → {hoyLargo}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1240, p = o.slide ?? Math.floor(t / 2.2) % 3, L = LIGHT(s, o), fr = pickN(D.hist.concat([D.heroItem]), 12);
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H);
    if (p === 0) {
      cover(ctx, D.heroItem.src, 0, 0, W, H, 1.02); ctx.fillStyle = 'rgba(7,11,9,.55)'; ctx.fillRect(0, 0, W, H);
      text(ctx, o.titulo.toUpperCase(), 90 * s, H - 620 * s, { size: 30 * s, color: o.accent, ls: 6 * s, weight: 700 });
      text(ctx, D.obra, 90 * s, H - 560 * s, { size: 130 * s, color: '#fff', maxW: W - 180 * s });
      text(ctx, fill(o.sub, D), 90 * s, H - 290 * s, { size: 34 * s, color: '#fff', weight: 500 });
      text(ctx, num(D.dias) + ' días · +' + num(D.fotos) + ' fotos', 90 * s, H - 220 * s, { size: 34 * s, color: o.accent, weight: 600 });
      brand(ctx, W, H, D, Object.assign({}, o, { marca: false }), { chipX: 90 * s, chipY: 90 * s });
    } else {
      const set = fr.slice((p - 1) * 6, p * 6), cw = (W - 180 * s - 40 * s) / 2, chh = 430 * s;
      text(ctx, p === 1 ? 'Primera etapa' : 'Hasta hoy', 90 * s, 70 * s, { size: 56 * s, color: L.ink });
      set.forEach((f, i) => {
        const x = 90 * s + (i % 2) * (cw + 40 * s), y = 180 * s + Math.floor(i / 2) * (chh + 100 * s), fe = f.fecha || D.hoyFecha;
        rr(ctx, x, y, cw, chh, 14 * s); ctx.save(); ctx.clip(); cover(ctx, f.src, x, y, cw, chh); ctx.restore();
        text(ctx, fdate(fe, true), x, y + chh + 16 * s, { size: 28 * s, color: L.ink, weight: 600 });
        text(ctx, 'Día ' + num(dayOf(D, fe)), x + cw, y + chh + 16 * s, { size: 26 * s, color: L.mut, weight: 500, align: 'right' });
      });
      text(ctx, 'Página ' + (p + 1) + ' de 3', W - 90 * s, H - 80 * s, { size: 22 * s, color: L.mut, align: 'right', weight: 500 });
    }
  } });

add({ id: 'pdf-presentacion', nombre: 'Presentación horizontal (PDF)', tipo: 'pdf', fmt: 'A4h', dur: 0, cat: ['pdf'], slides: 2, nuevo: 1, alta: '2026-10-02',
  desc: 'Dos láminas apaisadas para mostrar en reuniones o pantallas.',
  titulo: '{obra}', sub: 'Avance al {hoyLargo}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1754, p = o.slide ?? Math.floor(t / 2.4) % 2;
    ctx.fillStyle = '#070B09'; ctx.fillRect(0, 0, W, H);
    if (p === 0) {
      cover(ctx, D.heroItem.src, W * .42, 0, W * .58, H, 1.02);
      const g = ctx.createLinearGradient(W * .42, 0, W * .6, 0); g.addColorStop(0, '#070B09'); g.addColorStop(1, 'rgba(7,11,9,0)'); ctx.fillStyle = g; ctx.fillRect(W * .42, 0, W * .2, H);
      brand(ctx, W, H, D, Object.assign({}, o, { marca: false }), { chipX: 100 * s, chipY: 100 * s });
      text(ctx, o.titulo, 100 * s, 360 * s, { size: 120 * s, color: '#fff', maxW: W * .38 });
      text(ctx, o.sub, 100 * s, 760 * s, { size: 36 * s, color: o.accent, weight: 600, maxW: W * .36 });
      text(ctx, num(D.dias) + ' días de obra registrados', 100 * s, 830 * s, { size: 32 * s, color: 'rgba(255,255,255,.75)', weight: 500 });
    } else {
      const hw = (W - 260 * s) / 2, hh = H - 400 * s;
      text(ctx, 'Del primer día a hoy', 100 * s, 90 * s, { size: 72 * s, color: '#fff' });
      [[D.hist[0], 'INICIO'], [D.heroItem, 'HOY']].forEach(([f, l], i) => {
        const x = 100 * s + i * (hw + 60 * s), y = 230 * s;
        rr(ctx, x, y, hw, hh, 20 * s); ctx.save(); ctx.clip(); cover(ctx, f.src, x, y, hw, hh); ctx.restore();
        pill(ctx, l + ' · ' + fdate(f.fecha || D.hoyFecha).toUpperCase(), x + 24 * s, y + 24 * s, { size: 28 * s, bg: i ? o.accent : 'rgba(0,0,0,.6)', color: i ? '#06100b' : '#fff' });
      });
      text(ctx, D.cliente + ' · ' + (D.lugar || '') , 100 * s, H - 120 * s, { size: 30 * s, color: 'rgba(255,255,255,.7)', weight: 500 });
    }
  } });

add({ id: 'pdf-carta', nombre: 'Carta a compradores (PDF)', tipo: 'pdf', fmt: 'A4', dur: 0, cat: ['pdf'], slides: 1, nuevo: 1, alta: '2026-10-02',
  desc: 'Una hoja con mensaje editable para mandar a quienes compraron.',
  titulo: 'Queremos contarte cómo avanza tu futuro hogar. Cada foto de esta hoja la tomó la cámara instalada en la obra.', sub: 'Equipo de {cliente}',
  render(ctx, W, H, t, D, o) {
    const s = W / 1240, L = LIGHT(s, o);
    ctx.fillStyle = '#faf9f6'; ctx.fillRect(0, 0, W, H);
    brand(ctx, W, H, D, Object.assign({}, o, { marca: false }), { chipX: 90 * s, chipY: 80 * s });
    text(ctx, fdate(D.hoyFecha, true), W - 90 * s, 100 * s, { size: 26 * s, color: L.mut, align: 'right', weight: 500 });
    text(ctx, 'Novedades de ' + D.obra, 90 * s, 260 * s, { size: 70 * s, color: L.ink, maxW: W - 180 * s, fam: 'Playfair Display' });
    text(ctx, o.titulo, 90 * s, 470 * s, { size: 34 * s, color: L.ink, weight: 400, maxW: W - 180 * s, lh: 1.45 });
    const hw = (W - 180 * s - 30 * s) / 2;
    [[D.hist[Math.floor(D.hist.length / 2)], 'Hace un tiempo'], [D.heroItem, 'Hoy']].forEach(([f, l], i) => {
      const x = 90 * s + i * (hw + 30 * s), y = 760 * s;
      cover(ctx, f.src, x, y, hw, 520 * s);
      text(ctx, l + ' · ' + fdate(f.fecha || D.hoyFecha), x, y + 540 * s, { size: 26 * s, color: L.mut, weight: 500 });
    });
    ctx.fillStyle = o.accent; ctx.fillRect(90 * s, H - 240 * s, 70 * s, 6 * s);
    text(ctx, fill(o.sub, D), 90 * s, H - 210 * s, { size: 34 * s, color: L.ink, weight: 600 });
    text(ctx, 'Podés seguir la obra en vivo cuando quieras' + (D.ig ? ' · ' + D.ig : ''), 90 * s, H - 150 * s, { size: 26 * s, color: L.mut, weight: 500 });
  } });

add({ id: 'gente-hoy', nombre: 'Hoy trabajaron…', tipo: 'story', fmt: '9:16', dur: 6, cat: ['story', 'avance'], requires: 'ia', nuevo: 1, alta: '2026-10-02', trend: 1,
  desc: 'Cuántas personas trabajaron en la obra, contadas por la IA.',
  titulo: 'personas trabajaron hoy en {obra}', sub: 'Contadas por la IA de nuestra cámara',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080;
    cover(ctx, D.heroItem.src, 0, 0, W, H, 1.06 + .05 * t / 6); ctx.fillStyle = 'rgba(7,11,9,.6)'; ctx.fillRect(0, 0, W, H);
    brand(ctx, W, H, D, o);
    if (!hasIA(D)) return;
    const d = D.ia.dias.slice().reverse().find((x) => x.max > 0) || D.ia.dias[D.ia.dias.length - 1];
    const k = easeOut(seg(t, .3, 2.2));
    text(ctx, String(Math.round(d.max * k)), W / 2, H * .26, { size: 360 * s, align: 'center', color: o.accent });
    text(ctx, fill(o.titulo, D), W / 2, H * .26 + 410 * s, { size: 56 * s, align: 'center', maxW: W - 160 * s });
    const a = easeOut(seg(t, 2.2, 3));
    ctx.globalAlpha = a;
    const items = [['🦺', d.max ? Math.round(d.casco / d.max * 100) + '% con casco' : '—'], ['⏱', (d.primera || '-') + ' a ' + (d.ultima || '-')], ['🚜', d.excavadoras + ' excavadoras']];
    items.forEach(([ic, l], i) => {
      const y = H * .62 + i * 110 * s;
      rr(ctx, 120 * s, y, W - 240 * s, 90 * s, 45 * s); ctx.fillStyle = 'rgba(255,255,255,.12)'; ctx.fill();
      text(ctx, ic + '  ' + l, W / 2, y + 22 * s, { size: 38 * s, align: 'center', weight: 600 });
    });
    text(ctx, o.sub, W / 2, H - 200 * s, { size: 30 * s, align: 'center', weight: 500, color: 'rgba(255,255,255,.8)' });
    ctx.globalAlpha = 1;
  } });


add({ id: 'carrusel-semana', nombre: 'Carrusel: avances de la semana', tipo: 'carrusel', fmt: '4:5', dur: 0, cat: ['carrusel', 'avance'], slides: 4, nuevo: 1, alta: '2026-10-02', trend: 1,
  desc: 'Sin filtros y en tiempo real: portada, antes y ahora, hitos de la semana y cierre.',
  titulo: 'Estructura completada; Avanza la mampostería; Llenado de losa', sub: 'Sin filtros y en tiempo real',
  render(ctx, W, H, t, D, o) {
    const s = W / 1080, i = o.slide ?? Math.floor(t / 1.6) % 4;
    const hitos = String(o.titulo || '').split(/[;\n]/).map((x) => x.trim()).filter(Boolean).slice(0, 5);
    const prev = D.hist[Math.max(0, D.hist.length - 2)];
    if (i === 0) {
      cover(ctx, D.heroItem.src, 0, 0, W, H, 1.04); shade(ctx, W, H, .35, .9);
      pill(ctx, '● ' + o.sub.toUpperCase(), 60 * s, H - 520 * s, { size: 26 * s, bg: '#e11d2a', ls: 2 * s });
      text(ctx, 'Así avanza ' + D.obra + ' esta semana', 60 * s, H - 430 * s, { size: 84 * s, maxW: W - 120 * s, shadow: 1 });
      text(ctx, 'Deslizá para ver las capturas →', 60 * s, H - 130 * s, { size: 32 * s, color: o.accent, weight: 600 });
    } else if (i === 1) {
      ctx.fillStyle = '#070B09'; ctx.fillRect(0, 0, W, H);
      const hh = (H - 60 * s) / 2;
      cover(ctx, prev.src, 0, 0, W, hh); cover(ctx, D.heroItem.src, 0, hh + 60 * s, W, hh);
      pill(ctx, 'ANTES · ' + fdate(prev.fecha).toUpperCase(), 40 * s, 40 * s, { size: 26 * s, bg: 'rgba(0,0,0,.6)', ls: 2 * s });
      pill(ctx, 'AHORA · ' + fdate(D.hoyFecha).toUpperCase(), 40 * s, hh + 100 * s, { size: 26 * s, bg: o.accent, color: '#06100b', ls: 2 * s });
      text(ctx, 'en vivo desde la obra', W / 2, hh + 12 * s, { size: 26 * s, align: 'center', color: 'rgba(255,255,255,.7)', weight: 500 });
    } else if (i === 2) {
      cover(ctx, D.heroItem.src, 0, 0, W, H, 1.3); ctx.fillStyle = 'rgba(7,11,9,.86)'; ctx.fillRect(0, 0, W, H);
      text(ctx, 'RESUMEN DE AVANCES', 70 * s, 110 * s, { size: 30 * s, color: o.accent, ls: 5 * s, weight: 700 });
      text(ctx, D.obra, 70 * s, 160 * s, { size: 72 * s, maxW: W - 140 * s });
      (hitos.length ? hitos : ['Seguimos avanzando']).forEach((h, k) => {
        const y = 380 * s + k * 170 * s;
        rr(ctx, 70 * s, y, W - 140 * s, 140 * s, 24 * s); ctx.fillStyle = 'rgba(255,255,255,.08)'; ctx.fill();
        dot(ctx, 140 * s, y + 70 * s, 26 * s, o.accent);
        text(ctx, '✓', 140 * s, y + 48 * s, { size: 34 * s, align: 'center', color: '#06100b' });
        text(ctx, h, 200 * s, y + 46 * s, { size: 40 * s, weight: 600, maxW: W - 320 * s });
      });
      text(ctx, 'Registrado con la cámara Lisual de la obra', 70 * s, H - 110 * s, { size: 26 * s, color: 'rgba(255,255,255,.65)', weight: 500 });
    } else {
      cover(ctx, D.heroItem.src, 0, 0, W, H, 1.15); ctx.fillStyle = 'rgba(7,11,9,.8)'; ctx.fillRect(0, 0, W, H);
      text(ctx, 'Cumplir lo planificado y mostrarlo en cada paso.', W / 2, H * .3, { size: 70 * s, align: 'center', maxW: W - 160 * s });
      text(ctx, 'Seguí la obra en vivo', W / 2, H * .3 + 330 * s, { size: 40 * s, align: 'center', color: o.accent, weight: 600 });
      if (D.ig) text(ctx, D.ig, W / 2, H * .3 + 400 * s, { size: 36 * s, align: 'center', weight: 500 });
    }
    pill(ctx, (i + 1) + ' / 4', W - 50 * s, 50 * s, { size: 22 * s, align: 'right' });
    brand(ctx, W, H, D, Object.assign({}, o, { chip: i !== 1 }));
  } });

// ───────── datos derivados de la obra ─────────
function prepare(raw, clima) {
  const hist = raw.hist.slice().sort((a, b) => a.fecha.localeCompare(b.fecha));
  const heroItem = Object.assign({ fecha: raw.hoyFecha || '2026-09-29', hora: '13:00' }, (raw.hoy || []).reduce((a, b) => ((b.score || 0) > (a ? (a.score || 0) : -1) ? b : a), null) || hist[hist.length - 1]);
  heroItem.fecha = raw.hoyFecha || heroItem.fecha;
  const inicio = hist[0].fecha, hoyFecha = heroItem.fecha;
  const dias = Math.round((new Date(hoyFecha) - new Date(inicio)) / 864e5) + 1;
  const m = Math.max(1, Math.round(dias / 30.4));
  return Object.assign({ ig: '', lugar: '' }, raw, {
    hist, heroItem, inicio, hoyFecha, dias, fotos: dias * 66,
    meses: m === 1 ? '1 mes' : m + ' meses', clima,
  });
}
function fill(str, D) {
  const [y, m, d] = D.hoyFecha.split('-').map(Number);
  const map = { obra: D.obra, cliente: D.cliente, lugar: D.lugar, dias: num(D.dias), meses: D.meses, fotosN: '+' + num(D.fotos),
    hoyLargo: fdate(D.hoyFecha, true), hoyCorto: `${d} de ${MESES_L[m - 1]}`, mesAnio: `${MESES[m - 1]} ${y}`, mesAnioLargo: `${MESES_L[m - 1]} ${y}`,
    inicioLargo: fdate(D.inicio, true), iaDias: D.ia && D.ia.dias ? D.ia.dias.length : '', iaUltimoLargo: D.ia && D.ia.ultimo ? fdate(D.ia.ultimo, true) : '' };
  return String(str || '').replace(/\{(\w+)\}/g, (_, k) => map[k] ?? '');
}

const FMT = { '9:16': [1080, 1920], '4:5': [1080, 1350], '1:1': [1080, 1080], 'A4': [1240, 1754], 'A4h': [1754, 1240] };


export { T, FMT, prepare, fill, preload, fdate, num, MESES_L, setEstilo };
// helpers de dibujo (los usa también el módulo de Reporte PDF)
export { img, cover, rr, text, pill, dot, font, clamp, easeOut, fmes, pickN, MESES };
